import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  Children,
  cloneElement,
} from "react";
import ConfirmationModal from "../../widgets/ConfirmationModal";
import { CommonDataTable } from "../../common-components/common-material-react-table/CommonMaterialTable";
import { OTISRecords } from "../../constants/tableConstants/tableHeaders";
// import { Controller, useForm } from "react-hook-form";
import { useFetcher, useNavigate, useParams } from "react-router-dom";
import { FaCopy, FaCheck, FaTimes } from "react-icons/fa";
import { useLocation } from "react-router-dom";
// import { ArrowLongLeftIcon, ArrowLongRightIcon } from "@heroicons/react/24/solid";

import {
  FetchOTISRecord,
  otisRecordInterface,
  updateSelectedOTISRecord,
  updateTableData,
  emptySelectedOTISData,
  // segDetailsInterface,
  emptyUpdatedOtisStatus,
  addRowInOTISRecords,
  removeOTISRow,
  updateSubmitBtn,
  updateSegTitle,
  updateSegINVNotes,
  updateEanSelectedValue,
  //  updateIsbnSelectedValue,
  fetchSelectedSegSummary,
  emptySelectedOtisSummary,
  updateEanNumberValue,
  updateSegOtisRecords,
  emptyInputsTest,
  removeNewRows,
  UpdatetableCond,
  scrollToBottom,
  SetvalueClear,
  setHandleSaveAll,
  handleLocalClear,
  handleInputClear,
  setInputtedData,
  setCloseExpand,
  clearCompInitAction,
  UpdateTestRow,
  handleSaveButtonClear,
  setPubStart,
  clearAllEditableFields,
  SetaddrowcancelData,
  setselectedDistribution,
  setSelectedAccountName,
  setSelectedOrganization,
  setFinalData,
  setInputtedDataSt,
  UpdateSelectedTitleValue,
  UpdateSelectedIsbnValue,
  UpdateSelectedIsbnId,
  setSelectedSeg,
  emptysegDetails,
  setNoSegId,
  setLocal,
  clearSegDetails,
  UpdateSeason,
  setRenderSeason,
  setResetSeason,
  setIsCleared,
  setClearCompState,
} from "../../redux/reducers/OTISReducer";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import SelectList, {
  components,
  ControlProps,
  SingleValueProps,
} from "react-select";

import {
  MRT_Cell,
  MRT_Column,
  MRT_Row,
  MRT_RowData,
} from "material-react-table";
import { toast } from "react-toastify";
import isEqual from "lodash/isEqual";
import {
  fetchAccounts,
  // fetchIsbnList,
  fetchAllIsbnLists,
  ISBNData,
  resetAccountPage,
  resetIsbns,
  resetSkipForOtis,
  setClickedIsbn,
  setFetchDirection,
  setIsbnStringForOtis,
  setPreviousSkip,
  SetSteppingCalled,
  setSteppingDirection,
  updateAccountPage,
  updateIsbnSkipForOtis,
  updateIsbnSkipMinus,
  updateSearchStr,
} from "../../redux/reducers/ISBNSReducer";
import {
  emptyEansValue,
  fetchEans,
  updateEanPage,
  updateEanSearchStr,
  resetEanPage,
  setEansLoading,
} from "../../redux/reducers/EansReducer";
import { formatCurrency } from "../../common-components/commonFunctions";
import SearchSelect from "../../common-components/searchSelect";
import moment from "moment";
import {
  emptyGrossData,
  FetchgrossSales,
  grossUpdateRow,
} from "../../redux/reducers/GrossSalesReducer";
import { LinearProgress, debounce, Skeleton, useMediaQuery } from "@mui/material";
import {
  emptyCompInitData,
  FetchAllCompInitSales,
} from "../../redux/reducers/FetchAllCompInitReducer";
import {
  emptydigPosData,
  FetchdigPos,
} from "../../redux/reducers/fetchDigPosReducer";
import { useDebouncedFunction } from "../../common-components/UseAsyncDebouncQueue";
import axios from "axios";
import Test from "../../test";
import { dark } from "@mui/material/styles/createPalette";
import { stat } from "fs";
import { Root } from "react-dom/client";
import { table } from "console";
import TestTable from "./OtisTable";
import { Controller, useForm } from "react-hook-form";
import { FilterOTISDataById } from "./TableBody/FilterOTISData";
import { matchesOrganization } from "../../utils/otisCombinationUtils";
import { formatNumber } from "../../utils/formatNumber";

import {
  setExistedRow,
  setSelectedAccountId,
  setSelectedOrgId,
  setSelectedRepId,
} from "../../redux/reducers/Validationslice";
import { UpdateSelectedSeason } from "../../redux/reducers/SeasonReducer";
interface EditCellProps<TData extends MRT_RowData> {
  cell: MRT_Cell<TData>;
  column: MRT_Column<TData>;
  row: MRT_Row<TData>;
}
interface AccountData {
  initOrd?: string;
  sales_notes?: string;
  pub_goal?: string;
  printmtdDate?: string;
  currEst?: string;
  suppEst?: string;
  compInit?: string;
  compGross?: string;
  compNet?: string;
  retPercentage?: string;
  cpos4wkPOS?: string;
  cpos8wkPOS?: string;
  Cpos_LTD?: string;
  status?: string;
}

interface OptionType {
  value: string;
  label: string;
}

const OtisDetailsSkeleton = () => (
  <div className="p-4 h-[80vh] overflow-y-auto">
    <div className="space-y-3">
      <div className="rounded-md border border-gray-200 bg-white p-2">
        <Skeleton variant="text" width={150} height={20} sx={{ mb: 1 }} />
        {Array.from({ length: 6 }).map((_, idx) => (
          <div key={`otis-summary-skeleton-row-${idx}`} className="grid grid-cols-6 gap-2 mb-2">
            {Array.from({ length: 6 }).map((__, cellIdx) => (
              <Skeleton
                key={`otis-summary-skeleton-cell-${idx}-${cellIdx}`}
                variant="rounded"
                height={26}
              />
            ))}
          </div>
        ))}
      </div>

      <div className="rounded-md border border-gray-200 bg-white p-2">
        <div className="grid grid-cols-8 gap-2 mb-2">
          {Array.from({ length: 8 }).map((_, idx) => (
            <Skeleton key={`otis-table-head-skeleton-${idx}`} variant="rounded" height={28} />
          ))}
        </div>
        {Array.from({ length: 12 }).map((_, rowIdx) => (
          <div key={`otis-table-row-skeleton-${rowIdx}`} className="grid grid-cols-8 gap-2 mb-2">
            {Array.from({ length: 8 }).map((__, cellIdx) => (
              <Skeleton
                key={`otis-table-cell-skeleton-${rowIdx}-${cellIdx}`}
                variant="rounded"
                height={22}
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  </div>
);

const OtisInlineProgress = ({ text }: { text?: string }) => (
  <div className="mx-4 mt-2 rounded-md border border-gray-200 bg-white px-3 py-2 shadow-sm">
    <div className="overflow-hidden rounded-full">
      <LinearProgress
        sx={{
          height: 4,
          borderRadius: 9999,
          backgroundColor: "#f3f4f6",
          "& .MuiLinearProgress-bar": {
            borderRadius: 9999,
            background: "linear-gradient(90deg, #e31c23 0%, #fb7185 100%)",
          },
        }}
      />
    </div>
    <p className="mt-1 text-[11px] font-medium text-gray-500">
      {text || "Syncing changes..."}
    </p>
  </div>
);

/** Returns true if a top-level SEG OTIS record was removed (full replace required). */
function otisTableHasRecordDeletion(prev: any[], curr: any[]) {
  const currIds = new Set(
    (curr || []).map((r) => (r && r._id ? String(r._id) : ""))
  );
  return (prev || []).some(
    (r) => r && r._id && !currIds.has(String(r._id))
  );
}

/**
 * Decide whether to send the full table or only changed/new distribution-channel records.
 * Merge mode skips unchanged records to shrink the update payload.
 */
function getSegOtisSaveRecordsMode(prevTable: any[], currTable: any[]) {
  const prev = prevTable || [];
  const curr = currTable || [];
  if (prev.length === 0) {
    return { mode: "full" as const, records: curr };
  }
  if (otisTableHasRecordDeletion(prev, curr)) {
    return { mode: "full" as const, records: curr };
  }
  const prevById = new Map(
    prev.filter((r) => r && r._id).map((r) => [String(r._id), r])
  );
  const changed: any[] = [];
  for (const r of curr) {
    if (!r || !r._id) {
      return { mode: "full" as const, records: curr };
    }
    const id = String(r._id);
    if (!prevById.has(id)) {
      changed.push(r);
    } else if (!isEqual(prevById.get(id), r)) {
      changed.push(r);
    }
  }
  if (changed.length === 0) {
    return { mode: "full" as const, records: curr };
  }
  if (changed.length === curr.length) {
    return { mode: "full" as const, records: curr };
  }
  return { mode: "merge" as const, records: changed };
}

const OTISRecordsTable = () => {
  console.log("test");
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [isDisabled, setIsDisabled] = useState<boolean>(true);
  const [objectToUpdate, setObjectToUpdate] = useState<any>({});
  const [empty, setEmpty] = useState<boolean>(false);
  const [render, setRender] = useState(false);
  const [initialOrders, setIntialOrders] = useState<any>([]);
  const [LoadingTest, setLoadingTest] = useState(false);
  const [isText, setText] = useState<string>("");
  const [isModal, setModal] = useState(false);
  const [isSelectEan, setSelectEan] = useState(false);
  const [pendingEanSelection, setPendingEanSelection] = useState<any>(null);
  const [pendingTitle, setPendingTitle] = useState<string>("");
  const [isSelectEanSegTitle, setSelectEanSegTitle] = useState(false);
  const [pendingEanSegTitle, setpendingEanSegTitle] = useState<any>({});
  const location = useLocation();
  const hasMore = useSelector((state: RootState) => state.isbnReducer.hasMore);
  const hasPrevious = useSelector(
    (state: RootState) => state.isbnReducer.hasPrevious
  );
  const ClearCompState = useSelector(
    (state: RootState) => state.OTISReducer.ClearCompState
  );
  const params = useParams();
  console.log(params, "paraaaa");
  const navigate = useNavigate();
  const [accountData, setAccountData] = useState<Record<string, AccountData>>(
    {}
  );
  const isbnsStringForOtis = useSelector(
    (state: RootState) => state.isbnReducer.isbnsStringForOtis
  );

  const segId = params.segId ? params.segId : localStorage.getItem("segId");

  const isButtonDisabled = useSelector(
    (state: RootState) => state.OTISReducer.submitButtonDisabled
  );
  const SubmitHandleClear = useSelector(
    (state: RootState) => state.OTISReducer.SaveButtonClear
  );
  const selectedSeg = useSelector(
    (state: RootState) => state.OTISReducer.selectedSeg
  );
  let tableData = useSelector(
    (state: RootState) => state.OTISReducer?.data?.SEGOTISRecords || []
  );
  const finalData = useSelector(
    (state: RootState) => state.OTISReducer?.data?.finalData || []
  );
  let inputEmp = useSelector(
    (state: RootState) => state.OTISReducer.data.inputEmpty
  );
  console.log(inputEmp, "inputtttt");
  const tab = tableData.map(
    (item) => item.organizations.map((item) => item.orgName),
    "orgname"
  );
  let updatedTableData = useSelector(
    (state: RootState) => state.OTISReducer.TestRow
  );
  const segDetails = useSelector(
    (state: RootState) => state.OTISReducer.data.segDetails
  );
  console.log(segDetails, "segDetails");
  // const otisSegIsLoading = useSelector(
  //   (state: RootState) => state.OTISReducer.isLoading
  // );
  // const otisSegisText = useSelector(
  //   (state: RootState) => state.OTISReducer.isText
  // );
  const OTISId = useSelector((state: RootState) => state.OTISReducer.data._id);
  const SEGTitle = useSelector(
    (state: RootState) => state.OTISReducer.data.SEGTitle
  );
  const SEGINVNotes = useSelector(
    (state: RootState) => state.OTISReducer.data.SEGINVNotes
  );
  const userData = useSelector(
    (state: RootState) => state.UserReducer.userData
  );
  const selectedOtisSummary = useSelector(
    (state: RootState) => state.OTISReducer.data.selectedOtisSummary
  );
  const resetSeason = useSelector(
    (state: RootState) => state.OTISReducer.resetSeason
  );

  const updateOTISRecordStatus = useSelector(
    (state: RootState) => state.OTISReducer.updateOtis.status
  );
  const accounts = useSelector(
    (state: RootState) => state.isbnReducer.accounts
  );
  const dispatch = useDispatch<AppDispatch>();

  // Dedupe identical fetchOTISRecord dispatches within a short window (StrictMode double-mount,
  // overlapping effects) without changing API contracts.
  const lastOtisFetchRef = useRef<{ key: string; at: number }>({ key: "", at: 0 });
  const OTIS_FETCH_DEDUP_MS = 2800;
  const shouldSkipDuplicateOtisFetch = (payload: Record<string, unknown>) => {
    const key = JSON.stringify(payload);
    const now = Date.now();
    const prev = lastOtisFetchRef.current;
    if (prev.key === key && now - prev.at < OTIS_FETCH_DEDUP_MS) {
      return true;
    }
    lastOtisFetchRef.current = { key, at: now };
    return false;
  };

  const eanSelectedValue = useSelector(
    (state: RootState) => state.OTISReducer.data.eanSelectedValue
  );
  const eanSelectedValueRef = useRef(eanSelectedValue);
  eanSelectedValueRef.current = eanSelectedValue;
  const eanNumberValue = useSelector(
    (state: RootState) => state.OTISReducer.data.eanNumberValue
  );
  const eans = useSelector((state: RootState) => state.eanReducer.eans);
  const inputtedDataSt = useSelector(
    (state: RootState) => state.OTISReducer.inputtedDataSt
  );
  const DataOfFetchotis = useSelector(
    (state: RootState) => state.OTISReducer.data.segDetails
  );
  console.log(DataOfFetchotis, "DataOfFetchotis");
  const isbnss = useSelector((state: RootState) => state.isbnReducer.isbns);
  const steppingCalled = useSelector(
    (state: RootState) => state.isbnReducer.steppingCalled
  );
  const steppingDirection = useSelector(
    (state: RootState) => state.isbnReducer.steppingDirection
  );
  console.log(isbnss, "isbnss");
  const eanNumberOptions = useMemo(
    () =>
      eans.eans
        ? eans.eans.map((ean) => {
            return { value: ean._id, label: ean.ISBN };
          })
        : [],
    [eans.eans]
  );
  const eanTitleOptions = useMemo(
    () =>
      eans.eans
        ? eans.eans.map((ean) => {
            return { value: ean._id, label: ean.FULL_TITLE };
          })
        : [],
    [eans.eans]
  );

  useEffect(() => {
    console.log("eanNumberOptions");
  }, [eans]);
  const isSmallScreen = useMediaQuery("(max-width:1152px)");
  const isFirefox =
    typeof navigator !== "undefined" && navigator.userAgent.includes("Firefox");

  console.log("eanNumberOptions", eanNumberOptions);
  let saveRowCondition = useSelector(
    (state: RootState) => state.OTISReducer.saveRowHandle
  );
  const accountNameSelectedOptions = useMemo(
    () =>
      accounts.accounts
        ? accounts.accounts.map((account) => {
            return { value: account._id, label: account.ACCOUNT_NAME };
          })
        : [],
    [accounts.accounts]
  );
  const segSummaryLimit = useSelector(
    (state: RootState) => state.SegReducer.limit
  );
  const saveAllData = useSelector(
    (state: RootState) => state.OTISReducer.saveAllData
  );
  const localClearData = useSelector(
    (state: RootState) => state.OTISReducer.localClear
  );
  const UpdateTableCondition = useSelector(
    (state: RootState) => state.OTISReducer.UpdateTableCondition
  );
  const inputClear = useSelector(
    (state: RootState) => state.OTISReducer.inputClear
  );
  const inputtedData = useSelector(
    (state: RootState) => state.OTISReducer.inputtedData
  );
  const data = useSelector(
    (state: RootState) => state.OTISReducer.data.segDetails
  );

  const renderSeason = useSelector(
    (state: RootState) => state.OTISReducer.renderSeason
  );
  console.log(data, "data22");
  const Allisbns = useSelector(
    (state: RootState) => state.isbnReducer.Allisbns
  );
  const oldISBNS = Allisbns?.length
    ? Allisbns.map((isbn: any) => isbn._id)
    : [];
  const isbnLimit = useSelector(
    (state: RootState) => state.isbnReducer.isbnLimit
  );
  const isbnSkipForOtis = useSelector(
    (state: RootState) => state.isbnReducer.isbnSkipForOtis
  );
  const previousSkip = useSelector(
    (state: RootState) => state.isbnReducer.previousSkip
  );
  const fetchDirection = useSelector(
    (state: RootState) => state.isbnReducer.fetchDirection
  );
  const clickedIsbn = useSelector(
    (state: RootState) => state.isbnReducer.clickedIsbn
  );

  const clickedIsbnFromLocal = localStorage.getItem("clickedIsbn");
  const selectedSeason = useSelector(
    (state: RootState) => state.SeasonReducer.selectedSeason
  );
  const selectedDivision = useSelector(
    (state: RootState) => state.DivisionReducer.selectedDivision ?? []
  );
  const selectedImprint = useSelector(
    (state: RootState) => state.ImprintReducer.selectedImprint ?? []
  );
  const selectedPaperCutOffDate = useSelector(
    (state: RootState) => state.PaperCutOffDateReducer.selectedPaperCutOffDate ?? []
  );
  const selectedLdc = useSelector(
    (state: RootState) => state.LdcReducer.selectedLdc ?? []
  );
  const selectedISBNS = useSelector(
    (state: RootState) => state.isbnReducer.selectedISBNS ?? []
  );
  const selectedTitles = useSelector(
    (state: RootState) => state.isbnReducer.selectedTitles ?? []
  );

  const SegReducer = useSelector((state: RootState) => state.SegReducer);

  const [show, setShow] = useState<boolean>(true);
  const [addRow, setAddRow] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [selectedSegTitle, setSelectedSegTitle] = useState<any>({
    label: "",
    value: "",
  });
  const [selectedSegIsbn, setSelectedSegIsbn] = useState<any>({
    label: "",
    value: "",
  });
  const [isbn_title_options, set_ISBN_TITLE_OPTION] = useState<OptionType[]>(
    []
  );
  const [isbn_number_options, set_ISBN_NUMBER_OPTION] = useState<OptionType[]>(
    []
  );
  const { control, watch, reset, setValue } = useForm();

  const local = useSelector((state: RootState) => state.OTISReducer.local);
  const noSegId = useSelector((state: RootState) => state.OTISReducer.noSegId);

  const dataOfComp = useSelector(
    (state: RootState) => state.OTISReducer.data.selectedOtisSummary
  );

  console.log(dataOfComp?.SEASON, "dataOfComp");
  const FetchOtisLoading = useSelector(
    (state: RootState) => state.OTISReducer.FetchOtisLoading
  );
  const filterSeasons = selectedSeason ?? [];
  const filterDivisions = selectedDivision ?? [];
  const filterImprint = selectedImprint ?? [];

  console.log("selectedSeason", selectedSeason);
  useEffect(() => {
    dispatch(setIsbnStringForOtis(""));
    commonIsbnfunction();
  }, [isbnsStringForOtis, isbnSkipForOtis]);
  const isModalOpen = isSelectEan || isSelectEanSegTitle; // Check if any ConfirmationModal is open
  const filterIsbns = useMemo(
    () => [...new Set([...selectedISBNS, ...selectedTitles])],
    [selectedISBNS, selectedTitles]
  );

  const commonIsbnfunction = () => {
    dispatch(
      fetchAllIsbnLists({
        seasons: filterSeasons,
        divisions: filterDivisions,
        isbns: filterIsbns,
        imprint: filterImprint,
        prevSeason: filterSeasons,
        prevDivision: filterDivisions,
        prevImprint: filterImprint,
        prevPaperCutOffDate: selectedPaperCutOffDate,
        paperCutOffDate: selectedPaperCutOffDate,
        prevLdc: selectedLdc,
        ldc: selectedLdc,
        oldEans: oldISBNS,
        selectedData: [],
        searchStr: isbnsStringForOtis,
        sortBy: SegReducer.titleSortBy,
        clickedIsbn: clickedIsbn || clickedIsbnFromLocal,
        direction: fetchDirection,
      })
    );

    dispatch(setFetchDirection(""));
  };

  useEffect(() => {
    if (Allisbns?.length) {
      const originalOptions = Allisbns.map((isbn: any) => ({
        value: isbn._id ?? "",
        label: isbn.ISBN ?? "",
      }));

      const titleOptions = Allisbns.map((isbn: any) => ({
        value: isbn._id ?? "",
        label: isbn.FULL_TITLE ?? "",
      }));

      set_ISBN_NUMBER_OPTION(originalOptions);
      set_ISBN_TITLE_OPTION(titleOptions);
    }
  }, [Allisbns]);

  useEffect(() => {
    return () => {
      dispatch(emptySelectedOTISData());
      dispatch(emptyEansValue());
    };
  }, []);

  const clearCompInit = async () => {
    try {
      dispatch(setClearCompState(true));
      setLoadingTest(true);
      const response = await axios.post("OTIS/clearCompInit", {
        segId: segId ? segId : selectedSeg,
      });

      // dispatch(updateEanSelectedValue(null))
      // dispatch(UpdateSelectedTitleValue(null))
      // dispatch(updateEanNumberValue(null))
      // dispatch(updateSegOtisRecords([]))
      // dispatch(
      //   FetchOTISRecord({
      //     segId: segId,
      //     EAN: segDetails?.EAN,
      //     hasMoreLimit: Number(segSummaryLimit) + 1,
      //   })
      // );
      // Ensure compInit is reset to empty string or "0"
      const updatedTableData = tableData.map((record: any) => ({
        ...record,
        organizations: record.organizations.map((org: any) => ({
          ...org,
          accounts: org.accounts.map((account: any) => ({
            ...account,
            compInit: "", // Reset to empty string
          })),
        })),
      }));

      // dispatch(updateSegOtisRecords(updatedTableData));
      dispatch(updateEanSearchStr(""));
      setLoadingTest(false);
      setText("");
    } catch (error) {
      dispatch(setClearCompState(false));
      console.error("Error fetching OTIS record:", error);
      setLoadingTest(false);
      setText("");
    }
  };
  useEffect(() => {
    if (ClearCompState) {
      console.log(ClearCompState, "ClearCompState");
    }
  }, [ClearCompState]);
  const debouncedFetchEans = useDebouncedFunction(
    (params: {
      type: string;
      searchStr: string;
      page: number;
      limit: number;
      oldEans: string[];
    }) => dispatch(fetchEans(params)),
    300 // Debounce delay in milliseconds
  );
  useEffect(() => {
    const oldEans = eans.eans?.length
      ? eans.eans.map((ean: any) => ean._id)
      : [];
    // Trigger the debounced API call
    debouncedFetchEans({
      type: "all",
      searchStr: eans.searchStr,
      page: eans.page,
      limit: eans.limit,
      oldEans: [],
    }).catch(console.error);
  }, [eans.searchStr, eans.page, eans.limit]);
  const debouncedFetchAccounts = useDebouncedFunction(
    (params: {
      searchStr: string;
      page: number;
      limit: number;
      oldAccounts: string[];
    }) => {
      return dispatch(fetchAccounts(params));
    },
    300
  );
  useEffect(() => {
    const oldAccounts = accounts.accounts?.length
      ? accounts.accounts.map((account: { _id: string }) => account._id)
      : [];
    // Trigger the debounced API call
    debouncedFetchAccounts({
      searchStr: accounts.searchStr,
      page: accounts.page,
      limit: accounts.limit,
      oldAccounts: oldAccounts,
    }).catch(console.error);
  }, [accounts.searchStr, accounts.page, accounts.limit]); // Add `accounts.limit` if needed
  const digPosData = useSelector((state: RootState) => state.digPosReducer);
  const [newData, setNewUpdate] = useState<any>(tableData);

  useEffect(() => {
    console.log("setNewUpdatetabledata", tableData);
    setNewUpdate(tableData);
  }, [tableData]);

  // useEffect(() => {
  //   if(!params.segId || location.pathname === "/details"){
  // console.log(segDetails.EAN,selectedSeg,'2222222222222222222222')
  //      localStorage.removeItem("segId");
  //      setSelectedSeg(null)
  //   }

  // }, [location.pathname]);

  // Load comp-title side data only when the *selected comp title id* or *SEG* changes.
  // Do NOT list segDetails / eanNumberValue / segSummaryLimit here: they update after
  // fetchSelectedSegSummary / FetchOTISRecord / FetchOTISRecord, which would retrigger this
  // effect in a loop. Also depend on eanSelectedValue?.value (primitive), not the object
  // reference, because Redux may replace the option object after fetch with an equivalent one.
  useEffect(() => {
    const fetchData = async () => {
      if (!eanSelectedValue) return;

      try {
        setText("Comparing Comp Title , Please Wait");
        setLoadingTest(true);
        setAddRow(false);

        await Promise.allSettled([
          dispatch(fetchSelectedSegSummary(eanSelectedValue)).unwrap(),
          dispatch(FetchdigPos(eanSelectedValue)).unwrap(),
        ]);

        const otisPayload: Record<string, unknown> = {
          segId: segId,
          eanSelectedValue: eanNumberValue?.label,
          EAN: segDetails?.EAN,
          hasMoreLimit: Number(segSummaryLimit) + 1,
        };

        if (shouldSkipDuplicateOtisFetch(otisPayload)) {
          setSelectEan(false);
          return;
        }

        await dispatch(FetchOTISRecord(otisPayload)).unwrap();
        setSelectEan(false);
      } catch (error) {
        console.error("Error fetching OTIS record:", error);
        setText("");
      } finally {
        setLoadingTest(false);
      }
    };
    void fetchData();
  }, [eanSelectedValue?.value, segId]);

  useEffect(() => {
    setNewUpdate(tableData);
  }, [tableData]);

  // After fetch: if persisted filters exist and no records match for this ISBN, clear filters and show toast (runs on latest tableData from Redux).
  useEffect(() => {
    let saved: {
      selectedRepIDS?: { value?: string; label?: string } | null;
      selectedOrgIDs?: { value?: string; label?: string } | null;
      selectedAccountIDs?: { value?: string; label?: string } | null;
    } = {};
    try {
      const raw = localStorage.getItem("savedFilterState");
      if (!raw) return;
      saved = JSON.parse(raw);
    } catch {
      return;
    }
    const distId = saved.selectedRepIDS?.value;
    const orgId = saved.selectedOrgIDs?.value;
    const accNum = saved.selectedAccountIDs?.value;
    const hasPersistedFilter =
      (distId != null && distId !== "") ||
      (orgId != null && orgId !== "") ||
      (accNum != null && accNum !== "");
    if (!hasPersistedFilter) return;

    const dataRef = tableData ?? [];
    const filteredById = FilterOTISDataById(
      dataRef,
      distId || null,
      orgId || null,
      accNum || null,
      saved.selectedOrgIDs?.label || null,
      saved.selectedAccountIDs?.label || null,
      saved.selectedRepIDS?.label || null
    );
    if (filteredById.length === 0) {
      toast.info("Accounts does not exist for selected filter.", { toastId: "otis-filter-no-match" });
      dispatch(setselectedDistribution(null));
      dispatch(setSelectedOrganization(null));
      dispatch(setSelectedAccountName(null));
      dispatch(setSelectedRepId(null));
      dispatch(setSelectedOrgId(null));
      dispatch(setSelectedAccountId(null));
      localStorage.removeItem("savedFilterState");
      localStorage.removeItem("saveFlag");
    }
  }, [tableData, segId, dispatch]);

  const { selectedAccountID, selectedOrgID, selectedRepID, selectedFieldData } =
    useSelector((state: any) => state.selection);
  const [eanState, setEanState] = useState<any>();
  const [mainTableData, setMainTableData] = useState<any>();
  useEffect(() => {
    setEanState(eanSelectedValue);
  }, [eanSelectedValue]);
  const [handleSaveData, setHandleSavedata] = useState<any>(updatedTableData);
  useEffect(() => {
    setHandleSavedata(updatedTableData);
  }, [updatedTableData]);
  useEffect(() => {
    if (UpdateTableCondition) {
      setHandleSavedata([]);
    }
  }, [UpdatetableCond]);
  const [count, setCount] = useState(0);
  const [selectedState, setSelectedState] = useState<string>(
    localStorage.getItem("selectedState") ?? ""
  );
  function compareArrays(arr1: any, arr2: any) {
    // Check if both arrays have the same length
    if (arr1.length !== arr2.length) {
      return false;
    }
    // Check if each object in arr1 matches the corresponding object in arr2
    for (let i = 0; i < arr1.length; i++) {
      // Compare the objects. Here we assume the objects can be compared using JSON.stringify
      if (JSON.stringify(arr1[i]) !== JSON.stringify(arr2[i])) {
        return false;
      }
    }
    return true; // All objects match
  }
  function mergeDummyDataWithFinal(finalData: any[], dummyData: any) {
    let repCodeExists = false;
    const updatedFinalData = finalData.map((repGroup) => {
      // Clone repGroup to avoid modifying the original object
      let newRepGroup = {
        ...repGroup,
        organizations: [...repGroup.organizations],
      };
      // If repCode matches
      if (newRepGroup.repCode === dummyData.repCode) {
        repCodeExists = true;
        // Check if organization exists in the repGroup
        const existingOrgIndex = newRepGroup.organizations.findIndex((org: any) =>
          matchesOrganization(org, dummyData.organizations[0])
        );
        if (existingOrgIndex !== -1) {
          // Clone the existing organization before modifying it
          let newOrg = { ...newRepGroup.organizations[existingOrgIndex] };
          // Clone and merge accounts to avoid modifying a frozen array
          newOrg.accounts = [
            ...(newOrg.accounts || []),
            ...dummyData.organizations[0].accounts,
          ];
          // Update the organization list with the cloned and modified organization
          newRepGroup.organizations[existingOrgIndex] = newOrg;
        } else {
          // Organization doesn't exist, add a cloned new organization
          newRepGroup.organizations.push({ ...dummyData.organizations[0] });
        }
      }
      return newRepGroup; // Return the updated repGroup
    });
    if (!repCodeExists) {
      updatedFinalData.push({ ...dummyData });
    }
    return updatedFinalData;
  }
  console.log(inputtedData, "inputtedData");
  const hasNew = useSelector((state: RootState) =>
    state.OTISReducer.data.SEGOTISRecords.some((a) => a.isNew === true)
  );
  const isFinalDataForCurrentIsbn = React.useMemo(() => {
    if (!Array.isArray(finalData) || finalData.length === 0) return false;
    if (!Array.isArray(tableData) || tableData.length === 0) return true;

    const tableIds = new Set(
      tableData
        .map((record: any) => (record?._id ? String(record._id) : ""))
        .filter(Boolean)
    );
    const finalIds = finalData
      .map((record: any) => (record?._id ? String(record._id) : ""))
      .filter(Boolean);

    // If finalData has no ids (e.g. add-row-only payload), allow using it.
    if (finalIds.length === 0) return true;
    return finalIds.some((id: string) => tableIds.has(id));
  }, [finalData, tableData]);

  const activeTableData = isFinalDataForCurrentIsbn
    ? finalData
    : tableData || [];

  const currentData = {
    tableData: activeTableData,
    ean: eanSelectedValue?.value || null,
    SEGINVNotes: SEGINVNotes || "",
    SEGTitle: SEGTitle || "",
  };

  useEffect(() => {
    console.log("local is", local);

    if (local) {
      console.log("local is currentData", currentData);
      localStorage.setItem("selectedState", JSON.stringify(currentData));

      setTimeout(() => {
        dispatch(setLocal(false));
      }, 3000);
    }
  }, [currentData, segId, local, params.segId, noSegId]);

  useEffect(() => {
    console.log("Initial state tableData:", tableData);
  }, [tableData, formData]);

  const handleSaveAll = async () => {
    dispatch(setPubStart(true));
    setSelectEan(false);
    dispatch(setInputtedData(false));
    dispatch(setInputtedDataSt(false));

    setIsSaving(true);
    setRender(!render);

    // Set loader text and show loader

    // Log initial state for debugging
    console.log("Initial state:", {
      tableData,
      finalData,
      eanSelectedValue,
      SEGTitle,
      SEGINVNotes,
      selectedRepID,
      selectedOrgID,
      selectedAccountID,
      inputtedData,
      formData,
    });

    // Validate formData for new rows (Sales Notes, Laydown Goal, Laydown Estimate, 6-month Estimate)
    // Treat "0" as empty so that clearing a numeric field doesn't count as valid input
    const hasValidFormData = Object.entries(formData).some(
      ([key, value]) =>
        key.startsWith("null---") &&
        value !== null &&
        value !== undefined &&
        value.toString().trim() !== "" &&
        value.toString().trim() !== "0"
    );

    console.log("hasValidFormData", hasValidFormData, inputtedData);

    // Validation for new rows
    if (hasNew && (!selectedAccountID || !selectedOrgID || !selectedRepID)) {
      toast.error(
        "Please select all three - Rep Code, Organization and Account Name",
        { toastId: "uniqueid" }
      );
      setIsSaving(false);
      setLoadingTest(false);
      return;
    }

    // Check if there is valid input data for new rows
    if (addRow && (!inputtedData || !hasValidFormData)) {
      // Line 22
      toast.error("No valid input data provided to save for new row.", {
        // Line 25
        toastId: "no-input-data-toast",
      });
      setIsSaving(false);
      setLoadingTest(false);
      return; // Line 31: Exit function
    }

    // Prepare current data
    const currentData = {
      // Line 32
      tableData: activeTableData, // Line 33
      ean: eanSelectedValue?.value || null, // Line 34
      SEGINVNotes: SEGINVNotes || "", // Line 35
      SEGTitle: SEGTitle || "", // Line 36
    };

    // Retrieve previous state from localStorage
    const prevData = JSON.parse(localStorage.getItem("selectedState") || "{}"); // Line 37

    // Custom deep comparison for table data
    const deepCompareTableData = (data1: any[], data2: any[]) => {
      // Line 38
      if (!data1 || !data2 || data1.length !== data2.length) return false; // Line 39

      return data1.every(
        // Line 40
        (
          record: {
            DISTRIBUTION_CHANNEL: any;
            DISTRIBUTION_CHANNEL_NAME: any;
            main_pubgoal: any;
            main_current_estimate: any;
            organizations: any[];
          },
          index: any
        ) => {
          const record2 = data2[index]; // Line 41
          if (!record2) return false; // Line 42

          // Compare top-level fields
          if (
            // Line 43
            record.DISTRIBUTION_CHANNEL !== record2.DISTRIBUTION_CHANNEL ||
            record.DISTRIBUTION_CHANNEL_NAME !==
              record2.DISTRIBUTION_CHANNEL_NAME ||
            record.main_pubgoal !== record2.main_pubgoal ||
            record.main_current_estimate !== record2.main_current_estimate
          ) {
            return false; // Line 44
          }

          // Compare organizations
          if (
            // Line 45
            !record.organizations ||
            !record2.organizations ||
            record.organizations.length !== record2.organizations.length
          ) {
            return false; // Line 46
          }

          return record.organizations.every(
            // Line 47
            (
              org: { organizationId: any; orgName: any; accounts: any[] },
              orgIndex: string | number
            ) => {
              const org2 = record2.organizations[orgIndex]; // Line 48
              if (!org2) return false; // Line 49

              if (
                // Line 50
                org.organizationId !== org2.organizationId ||
                org.orgName !== org2.orgName
              ) {
                return false; // Line 51
              }

              // Compare accounts
              if (
                // Line 52
                !org.accounts ||
                !org2.accounts ||
                org.accounts.length !== org2.accounts.length
              ) {
                return false; // Line 53
              }

              return org.accounts.every(
                // Line 54
                (account: { [x: string]: any }, accIndex: string | number) => {
                  const account2 = org2.accounts[accIndex]; // Line 55
                  if (!account2) return false; // Line 56

                  return Object.keys(OTISRecords) // Line 57
                    .slice(4)
                    .every((field) => {
                      const value1 = // Line 58
                        account[field]?.$numberDecimal || account[field] || "";
                      const value2 = // Line 59
                        account2[field]?.$numberDecimal ||
                        account2[field] ||
                        "";
                      return value1.toString() === value2.toString(); // Line 60
                    });
                }
              );
            }
          );
        }
      );
    };

    // Detect changes
    const hasTableChanged = !deepCompareTableData(
      // Line 61
      currentData.tableData,
      prevData.tableData || []
    );

    console.log("hasTableChanged", hasTableChanged); // Line 62
    console.log("hasTableChanged currentData.tableData", currentData.tableData); // Line 63
    console.log("hasTableChanged prevData.tableData", prevData.tableData); // Line 64

    // Explicitly check for EAN changes, including null transitions
    const hasEanChanged = // Line 65
      (currentData.ean === null && prevData.ean !== null) ||
      (currentData.ean !== null && currentData.ean !== prevData.ean);
    const hasSegTitleChanged = // Line 66
      currentData.SEGTitle !== (prevData.SEGTitle || "");
    const hasSegINVNotesChanged = // Line 67
      currentData.SEGINVNotes !== (prevData.SEGINVNotes || "");
    const hasFormDataChanged = hasValidFormData || inputtedData; // Line 68

    console.log("Change detection 2", hasValidFormData, inputtedData); // Line 69
    const hasChanges = // Line 70
      hasTableChanged ||
      hasEanChanged ||
      hasSegTitleChanged ||
      hasSegINVNotesChanged ||
      hasFormDataChanged;

    console.log("Change detection:", {
      // Line 71
      hasTableChanged,
      hasEanChanged,
      hasSegTitleChanged,
      hasSegINVNotesChanged,
      hasFormDataChanged,
      hasChanges,
    });

    console.log("hasChanges", hasChanges); // Line 72
    // If no changes, show toast and loader
    if (!hasChanges || noSegId) {
      // Line 73
      // setLoadingTest(true); // Line 75: Ensure loader is visible
      toast.error("Nothing to Update or Save.", {
        // Line 76
        toastId: "nothing-to-update-or-save-toast",
      });
      setIsSaving(false);
      setLoadingTest(false);
      return; // Line 82: Exit function
    }

    let updateScope:
      | "full"
      | "segINVNotesOnly"
      | "metadataOnly"
      | "mergeRecords" = "full";
    let resultForApi = currentData.tableData;

    if (!hasTableChanged && !hasFormDataChanged) {
      if (
        hasSegINVNotesChanged &&
        !hasEanChanged &&
        !hasSegTitleChanged
      ) {
        updateScope = "segINVNotesOnly";
      } else if (
        hasEanChanged ||
        hasSegTitleChanged ||
        hasSegINVNotesChanged
      ) {
        updateScope = "metadataOnly";
      }
    } else {
      const modeResult = getSegOtisSaveRecordsMode(
        prevData.tableData || [],
        currentData.tableData || []
      );
      if (modeResult.mode === "merge") {
        updateScope = "mergeRecords";
        resultForApi = modeResult.records;
      } else {
        updateScope = "full";
        resultForApi = currentData.tableData;
      }
    }

    // Check if any input is provided
    const hasAnyInput = // Line 83
      (SEGTitle && SEGTitle.trim().length > 0) ||
      (SEGINVNotes && SEGINVNotes.trim().length > 0) ||
      (eanSelectedValue && eanSelectedValue.value) ||
      hasValidFormData ||
      currentData.ean === null; // Allow save if EAN is removed

    console.log("hasAnyInput:", hasAnyInput); // Line 84

    const payload = {
      _id: OTISId || null,
      result: resultForApi,
      Title: SEGTitle || "",
      segINVNotes: SEGINVNotes || "",
      eanSelectedValue: currentData.ean,
      updateScope,
    };

    console.log("Payload to API:", payload);

    // Proceed with save
    try {
      // Line 92
      // Update localStorage with current state
      localStorage.setItem("selectedState", JSON.stringify(currentData)); // Line 93

      // Perform the save operation (unwrap so API/rejected thunks surface in catch)
      await dispatch(
        updateSelectedOTISRecord({
          _id: OTISId,
          result: resultForApi,
          Title: SEGTitle,
          segINVNotes: SEGINVNotes,
          eanSelectedValue: currentData.ean,
          updateScope,
        })
      ).unwrap();

      // Set saveFlag and show success message
      localStorage.setItem("saveFlag", JSON.stringify(true)); // Line 96
      setText("Saving Data, Please Wait");
      setLoadingTest(true);
      dispatch(setLocal(true)); // Line 100
      dispatch(handleSaveButtonClear(false)); // Line 101
      dispatch(setRenderSeason(true)); // Line 102
      dispatch(UpdateTestRow([])); // Line 103
      setFormData({}); // Line 104
      await dispatch(emptyUpdatedOtisStatus()); // Line 105
      await dispatch(updateSubmitBtn(true)); // Line 106
      setIsDisabled(true); // Line 107
      setAddRow(false); // Line 108

      // Restore filter state
      const savedFilterState = JSON.parse(
        // Line 109
        localStorage.getItem("savedFilterState") || "{}"
      );
      const { selectedRepIDS, selectedOrgIDs, selectedAccountIDs } =
        savedFilterState; // Line 110
      if (selectedRepIDS || selectedOrgIDs || selectedAccountIDs) {
        // Line 111
        dispatch(setSelectedRepId(selectedRepIDS || null)); // Line 112
        dispatch(setSelectedOrgId(selectedOrgIDs || null)); // Line 113
        dispatch(setSelectedAccountId(selectedAccountIDs || null)); // Line 114
        dispatch(setselectedDistribution(selectedRepIDS?.label || "")); // Line 115
        dispatch(setSelectedOrganization(selectedOrgIDs?.label || "")); // Line 116
        dispatch(setSelectedAccountName(selectedAccountIDs?.label || "")); // Line 117
      }

      await dispatch(
        FetchOTISRecord({
          segId: segId,
          EAN: segDetails?.EAN,
          hasMoreLimit: Number(segSummaryLimit) + 1,
        })
      ).unwrap();
      dispatch(scrollToBottom(false));
      toast.success("Your data has been saved successfully.", {
        toastId: "otis-save-success",
      });
      // Hide loader as soon as refetch completes — do not add a fixed delay on top of API time
      // (the old 2800ms timeout made the UI feel ~3s slower than the network).
      setIsSaving(false);
      setLoadingTest(false);
      setText("");
    } catch (err: any) {
      // Line 125
      console.error("Save Error:", err); // Line 126
      const errorMessage = err?.message || err?.toString() || "Unknown error"; // Line 127
      console.error("Detailed error:", {
        // Line 128
        error: err,
        status: err?.status,
        data: err?.data,
      });
      setText(`Failed to save records: ${errorMessage}`); // Line 129: Set loader message to match toast
      setLoadingTest(true); // Line 130: Ensure loader is visible
      toast.error(`Failed to save records: ${errorMessage}`, {
        // Line 131
        toastId: "save-error-toast",
      });
      setIsSaving(false);
      setLoadingTest(false);
      setText("");
    }
  };
  const callOtisRecord = async () => {
    dispatch(
      FetchOTISRecord({
        segId: segId,
        EAN: segDetails?.EAN,
        hasMoreLimit: Number(segSummaryLimit) + 1,
      })
    );
  };
  useEffect(() => {
    if (localClearData) {
      localStorage.removeItem("selectedState");
      dispatch(handleLocalClear(false));
    }
  }, [localClearData]);
  const handleCellEdit = async (cell: any, value: any, row: any) => {
    if (
      cell.column.id !== "account_name" &&
      cell.column.id !== "compInit" &&
      tableData[row.id].account_name === null
    ) {
      if (!tableData[row.id][cell.column.id as keyof otisRecordInterface]) {
        if (!toast.isActive("unique-toast-id")) {
          toast.error("Please select account name and account number", {
            toastId: "unique-toast-id",
          });
        }
        return;
      }
    }
    useEffect(() => {
      localStorage.setItem(
        "selectedState",
        JSON.stringify({ tableData: tableData, ean: eanSelectedValue })
      );
    }, [tableData, eanSelectedValue]);
    dispatch(updateSubmitBtn(false));
    if (cell.column.id === "account_name") {
      dispatch(resetAccountPage());
      dispatch(grossUpdateRow(row));
      dispatch(
        FetchgrossSales({
          accountName: value,
          EAN: eanNumberValue?.label,
          pub_date: selectedOtisSummary?.PUB_DATE,
        })
      );
      handleAccountChange(cell.column.id, value, row.id);
      return;
    }
    dispatch(
      updateTableData({
        rowIndex: row.id,
        cellName: cell.column.id as keyof otisRecordInterface,
        value: value,
      })
    );
  };
  const handleAccountChange = (cell: string, value: any, rowId: any) => {
    dispatch(
      updateTableData({
        rowIndex: rowId,
        cellName: "account_name" as keyof otisRecordInterface,
        value: value,
      })
    );
    dispatch(
      updateTableData({
        rowIndex: rowId,
        cellName: "account_id" as keyof otisRecordInterface,
        value: value && Object.keys(value).length ? value.value : "",
      })
    );
  };
  const handleClearAll = () => {
    onOptionSelect(null, "title"); // Clear Title selection
    onOptionSelect(null, "ean"); // Clear ISBN selection

    dispatch(UpdateTestRow([]));
    dispatch(handleSaveButtonClear(true));
    dispatch(emptySelectedOtisSummary());
    dispatch(updateEanNumberValue(null));
    dispatch(updateEanSelectedValue(null));
    dispatch(emptydigPosData());
    dispatch(updateSegTitle(""));
    dispatch(updateSegINVNotes(""));
    dispatch(emptyInputsTest(true));
    dispatch(clearAllEditableFields());
    setFormData({});
    setNewUpdate([]);

    dispatch(setInputtedData(false));
    dispatch(setInputtedDataSt(false));
    dispatch(setIsCleared(true));

    setModal(false);
    // Reset "unsaved data" confirmation modal state so it doesn't show when user types after Clear All
    setSelectEan(false);
    setSelectEanSegTitle(false);
    setPendingEanSelection(null);
    setpendingEanSegTitle(null);

    try {
      const hasValuesToClear = updatedTableData.some((data: any) =>
        Object.keys(data).some((key) => {
          const value = data[key];
          return value && value !== "0" && value !== "";
        })
      );
      if (hasValuesToClear) {
        dispatch(updateSubmitBtn(false));
      }
      setShow(true);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    const hasValuesToClear = tableData.some((data: any) =>
      Object.keys(data).some((key) => {
        const value = data[key];
        return value && value !== "0" && value !== "";
      })
    );
    setShow(!hasValuesToClear); // Disable button if no values
    if (Array.isArray(tableData) && tableData.length > 0) {
      const tableinitord = tableData[0].initOrd;
      if (tableinitord == null && tableData.length === 1) {
        setEmpty(true);
      } else {
        setEmpty(false);
      }
    } else {
      console.log("tableData is empty or undefined");
    }
  }, [tableData]);
  const grossData = useSelector((state: RootState) => state.GrossSalesReducer);
  useEffect(() => {
    const cell = {
      column: {
        id: "compInit",
      },
    };
    if (grossData.statusCode === 200) {
      handleCellEdit(cell, grossData.data.total_units, grossData.selectedRow);
    } else if (grossData.statusCode === 404) {
      handleCellEdit(cell, "", grossData.selectedRow);
    }
    dispatch(emptyGrossData());
  }, [grossData.statusCode, grossData.data]);
  useEffect(() => {
    dispatch(
      FetchAllCompInitSales({
        segTableData: tableData,
        EAN: selectedOtisSummary?.EAN,
        pub_date: selectedOtisSummary?.PUB_DATE,
        selectedSeg: segId ? segId : selectedSeg,
      })
    );
  }, []);
  const allCompInitData = useSelector(
    (state: RootState) => state.compInitReducer
  );
  useEffect(() => {
    if (allCompInitData.statusCode === 200) {
      dispatch(updateSegOtisRecords(allCompInitData.data));
    }
    dispatch(emptyCompInitData());
  }, [allCompInitData.statusCode, allCompInitData.data]);
  const handleAddRow = () => {
    if (noSegId) {
      toast.error("Please select Isbn and Title first in Seg Title table", {
        toastId: "uniqueid",
      });
      return;
    }
    localStorage.removeItem("selectedDistribution");
    localStorage.removeItem("selectedAboveOrganization");
    localStorage.removeItem("selectedAboveAccountName");
    dispatch(setFinalData(null));
    localStorage.removeItem("savedFilterState");
    localStorage.removeItem("saveFlag");
    dispatch(setExistedRow(false));
    setRender(!render);
    setAddRow(true);
    dispatch(addRowInOTISRecords());
    dispatch(SetvalueClear(true));
    dispatch(updateSubmitBtn(false));
    setCount(1);
  };
useEffect(() => {
  // Set saveFlag whenever inputtedData changes
  if (inputtedData) {
    localStorage.setItem("saveFlag", "true");
  }
}, [inputtedData]);
  useEffect(() => {
    if (addRow) {
      setLoadingTest(true);

      setTimeout(() => {
        try {
          dispatch(scrollToBottom(true));
        } catch (error) {
          console.error("Error in scrollToBottom:", error);
        } finally {
          setLoadingTest(false);
        }
      }, 100);
    }
  }, [addRow]);

  const tableStyles = {
    sx: {
      "& thead": {
        position: "sticky",
        top: 0,
      },
      "& tbody": {
        "& tr": {
          backgroundColor: "",
          "&:hover": {},
        },
        "& td": {
          "&:hover::after": {
            background: "none !important", // Disable background change on hover
            outline: "unset !important", // Remove outline
          },
          height: "0px",
          padding: "1px",
          '&[data-column="title"]': {
            "& > div": {
              maxWidth: "10px",
              "&::-webkit-scrollbar": {},
              "&::-webkit-scrollbar-thumb": {},
            },
          },
        },
      },
    },
  };
  const handleFocusNextInput = (event: any, cell: MRT_Cell<any>) => {
    event.stopPropagation();
    if (event.key === "Tab") {
      event.preventDefault();
      const elementId = cell.id.split("_");
      let focusElement;
      Object.keys(OTISRecords).map((e, index) => {
        if (cell.column.id === "suppEst" && e === cell.column.id) {
          focusElement = Object.keys(OTISRecords)[index + 2];
        } else if (e === cell.column.id) {
          focusElement = Object.keys(OTISRecords)[index + 1];
          if (index + 1 === Object.keys(OTISRecords).length)
            focusElement = Object.keys(OTISRecords)[0];
        }
      });
      const element = document.getElementById(
        `${Object.keys(OTISRecords)[Object.keys(OTISRecords).length - 1] ===
          `${elementId[1]}_${elementId[2]}`
            ? Number(elementId[0]) + 1
            : elementId[0]
        }_${focusElement}`
      );
      if (element) element.focus();
    }
  };

  useEffect(() => {
    console.log("finalData32", finalData);
  }, [finalData]);
  const handleRemoveRow = () => {
    dispatch(SetaddrowcancelData(true));
    setAddRow(false);
    dispatch(removeNewRows());
    dispatch(scrollToBottom(false));

    // dispatch(removeOTISRow());
    dispatch(setFinalData(null));
    localStorage.removeItem("selectedDistribution");
    localStorage.removeItem("selectedAboveOrganization");
    localStorage.removeItem("selectedAboveAccountName");
    localStorage.removeItem("savedFilterState");
    localStorage.removeItem("saveFlag");
  };

  //   const handleRemoveRow = () => {
  //   dispatch(SetaddrowcancelData(true))
  //   setAddRow(false);
  //   dispatch(removeNewRows());
  //   dispatch(scrollToBottom(false));
  // };

  useEffect(() => {
    const hasSeasonFilter = filterSeasons?.length > 0;
    if (hasSeasonFilter) {
      dispatch(setResetSeason(false));
    } else {
      dispatch(setResetSeason(true));
    }
  }, [filterSeasons]);

  const handleResetSeason = () => {
    dispatch(UpdateSelectedSeason([]));
    dispatch(setResetSeason(true));
    dispatch(resetSkipForOtis());
    dispatch(setRenderSeason(false));
    // dispatch(UpdateSeason(null))

    dispatch(
      fetchAllIsbnLists({
        prevSeason: [],
        prevDivision: [],
        prevImprint: [],
        prevPaperCutOffDate: [],
        paperCutOffDate: [],
        prevLdc: [],
        ldc: [],
        oldEans: oldISBNS,
        seasons: [],
        divisions: [],
        isbns: [],
        imprint: [],
        selectedData: [],
        sortBy: SegReducer.titleSortBy,
        clickedIsbn: clickedIsbn || clickedIsbnFromLocal,
      })
    );
    console.log("Page loaded or refreshed");
    dispatch(resetSkipForOtis());
    const currentPath = window.location.pathname;
    if (currentPath.startsWith("/details/")) {
      window.history.replaceState(null, "", "/details");
    }
    toast.success("Season Reset Successfully", {
      toastId: "success-toast",
    });
    navigate("/details");
  };

  const handleEanSelection = (value: any, title: string) => {
    setLoadingTest(false);
    setText("Comparing Comp Title , Please Wait"); // am

    // dispatch(setTextReducer("Comparing Comp Title 2, Please Wait"))
    if (value) {
      if (title === "title") {
        dispatch(updateEanSelectedValue(value));
        const eanNumber = eanNumberOptions.filter((ean) => {
          if (ean.value === value.value) return ean;
        })[0];
        dispatch(updateEanNumberValue(eanNumber));
      } else if (title === "ean") {
        dispatch(updateEanNumberValue(value));
        const eanTitle = eanTitleOptions.filter((ean) => {
          if (ean.value === value.value)
            return { value: ean.value, label: ean.label };
        })[0];
        dispatch(updateEanSelectedValue(eanTitle));
      }
    } else {
      dispatch(emptydigPosData());
      dispatch(emptySelectedOtisSummary());
      dispatch(updateEanNumberValue(null));
      dispatch(updateEanSelectedValue(null));
    }
  };
  //  const reorderOptions = (selectedValues: any, options: any) => {
  //     if (!selectedValues || selectedValues.length === 0) return options;
  //     const selectedIds = selectedValues?.map((selected: any) => selected.value);
  //     const filteredOptions = options.filter(
  //       (option: any) => !selectedIds.includes(option.value)
  //     );
  //     return [...selectedValues, ...filteredOptions];
  //   }

  const onOptionSelect = (value: any, title: string) => {
    dispatch(setClearCompState(false));
    console.log("onOptionSelect", value, title);
    setPendingEanSelection(value);
    setPendingTitle(title);
    console.log("value and title", value, title);
    dispatch(handleSaveButtonClear(true));

    if (inputtedData) {
      dispatch(setClearCompState(false));
      setSelectEan(true); // Show modal if there is unsaved data
    } else {
      handleContinue(value, title); // Proceed directly if no unsaved data
    }
    console.log("11alue", value);
  };

const onSegTitleSelect = (value: any, title: string) => {
    console.log("navigate", value);
    setpendingEanSegTitle(value);
    console.log("data edited", inputtedDataSt);
    console.log("data edited2", inputtedData);
    console.log("data edited3", value);

    // Check if SEG title is already blank
    const isSegTitleBlank = !selectedSegTitle?.value && !selectedSegIsbn?.value;

    // If SEG title is blank and user tries to clear it (value is null), skip modal and do nothing
    if (isSegTitleBlank && !value) {
        console.log("SEG title is already blank, skipping modal and state changes");
        setSelectEanSegTitle(false);
        return;
    }

    // If there is unsaved data and SEG title is not blank, show the modal
    if ((inputtedData || inputtedDataSt) && !isSegTitleBlank) {
        console.log("data edited inside if", inputtedDataSt);
        setSelectEanSegTitle(true);
    } else {
        console.log("data edited inside else", inputtedDataSt);
        console.log("before handle continue", value);
        handleContinue2(value, title); 
    }

    console.log("data edited neither if nor else", inputtedDataSt);
};
  console.log("inputFlag", inputtedData || inputtedDataSt);
  console.log(
    "inputFlag2",
    (inputtedData || inputtedDataSt) && isSelectEanSegTitle
  );

const handleContinue2 = (value?: any, title?: any) => {
    console.log("under the continue");

    console.log("value in continue2", value, title);
    if (value) {
        clearCompInit();
        dispatch(setNoSegId(false));
        dispatch(setLocal(true));
        dispatch(setRenderSeason(true));
        dispatch(UpdateSelectedIsbnValue(""));

      console.log("season24", DataOfFetchotis?.SEASON);
      // if (DataOfFetchotis?.SEASON) {
      //   localStorage.setItem("season", DataOfFetchotis?.SEASON);
      // }

        const eanNumber = isbn_number_options.filter((ean) => {
            if (ean.value === value.value) return ean;
        })[0];

        dispatch(setClickedIsbn(eanNumber?.label));

        if (title === "title") {
            setSelectedSegTitle(value);
            dispatch(UpdateSelectedTitleValue(value.label));
            const eanNumber = isbn_number_options.filter((ean) => {
                if (ean.value === value.value) return ean;
            })[0];
            console.log("eanNumber", eanNumber);
            dispatch(UpdateSelectedIsbnValue(eanNumber?.label));
            setSelectedSegIsbn(eanNumber);
        } else if (title === "ean") {
            setSelectedSegIsbn(value);
            dispatch(UpdateSelectedIsbnValue(value.label));
            const eanTitle = isbn_title_options.filter((ean) => {
                if (ean.value === value.value)
                    return { value: ean.value, label: ean.label };
            })[0];
            console.log("eanNumber2", eanTitle);
            setSelectedSegTitle(eanTitle);
            dispatch(UpdateSelectedTitleValue(eanTitle.label));
        }

        localStorage.setItem("segId", value?.value);
        setSelectEan(false);
        dispatch(SetSteppingCalled(false));
        dispatch(setInputtedData(false));
        dispatch(setInputtedDataSt(false));
        dispatch(UpdateTestRow([]));
        // Prevent cross-ISBN stale edits from being reused on save.
        dispatch(setFinalData([]));
        setFormData({});
        if (addRow) {
            console.log("under the add row");
            handleRemoveRow();
            dispatch(setFinalData([]));
            localStorage.removeItem("selectedDistribution");
            localStorage.removeItem("selectedAboveOrganization");
            localStorage.removeItem("selectedAboveAccountName");
            localStorage.removeItem("savedFilterState");
            localStorage.removeItem("saveFlag");
        }
        setSelectEanSegTitle(false);
        console.log("going to navigate", value);
        if (value?.value) {
            navigate(`/details/${value?.value}`);
        }
    } else {
        console.log("valueoncross545", value);
        dispatch(setNoSegId(true));
        dispatch(setRenderSeason(false));

        setSelectedSegTitle(null);
        setSelectedSegIsbn(null);
        setValue("segTableTitle", { label: "", value: "" });
        setValue("segTableIsbn", { label: "", value: "" });

        dispatch(setInputtedData(false));
        dispatch(setInputtedDataSt(false));
        dispatch(UpdateSelectedIsbnValue(""));
        dispatch(setSelectedSeg(null));

        localStorage.removeItem("segId");
        dispatch(UpdateSelectedTitleValue(""));
        dispatch(UpdateSelectedIsbnId(""));

        dispatch(updateSegOtisRecords([]));
        dispatch(emptysegDetails());
        dispatch(updateSegINVNotes(""));
        dispatch(updateSegTitle(""));

        setSelectEanSegTitle(false);

        navigate("/details");
    }

    dispatch(emptySelectedOtisSummary());
    dispatch(emptydigPosData());
    dispatch(updateEanNumberValue(null));
    dispatch(updateEanSelectedValue(null));
    setSelectEanSegTitle(false);
};
  const handleCancel2 = () => {
    // setpendingEanSegTitle({});
    setSelectEanSegTitle(false);
  };

  const onNextISBN = () => {
    // dispatch(setFetchDirection(""))
    const currentIndex = isbn_number_options.findIndex(
      (item) => item.value === segId
    );

    dispatch(SetSteppingCalled(true));
    dispatch(setSteppingDirection("next"));
    dispatch(setFetchDirection("next"));

    // First time: no match found
    if (currentIndex === -1) {
      if (isbn_number_options.length > 0) {
        const first = isbn_number_options[0];
        if (first.value !== segId) {
          onSegTitleSelect(first, "ean");
        } else if (isbn_number_options.length > 1) {
          onSegTitleSelect(isbn_number_options[1], "ean");
        } else if (hasMore) {
          console.log("under hasmore");
          dispatch(updateIsbnSkipForOtis());
        }
      }
      return;
    }

    const next = isbn_number_options[currentIndex + 1];
    if (next) {
      onSegTitleSelect(next, "ean");
    } else if (hasMore) {
      dispatch(resetIsbns()); // Optional: if you're replacing on each page
      console.log("under hasmore 2", isbnSkipForOtis);

      dispatch(updateIsbnSkipForOtis());
    } else {
      toast.error(
        `No records found${filterSeasons.length > 0 ? ` for season ${filterSeasons[0]}` : ""
        }.`,
        { toastId: "uniqueid" }
      );
    }
  };

  const onPrevISBN = () => {
    const currentIndex = isbn_number_options.findIndex(
      (item) => item.value === segId
    );

    if (currentIndex === -1) {
      toast.error(
        `No records found${filterSeasons.length > 0 ? ` for season ${filterSeasons[0]}` : ""
        }.`,
        { toastId: "uniqueid" }
      );

      return;
    }

    dispatch(setFetchDirection("prev"));

    const prev = isbn_number_options[currentIndex - 1];

    if (prev) {
      dispatch(SetSteppingCalled(true));
      dispatch(setSteppingDirection("prev"));
      onSegTitleSelect(prev, "ean");
    } else {
      if (isbnSkipForOtis > 0 || hasPrevious) {
        console.log("under this");
        dispatch(SetSteppingCalled(true));
        dispatch(setSteppingDirection("prev"));
        dispatch(resetIsbns());
        dispatch(updateIsbnSkipMinus());
      } else {
        toast.error(
          `No records found${filterSeasons.length > 0
              ? ` for season ${filterSeasons[0]}`
              : ""
          }.`,
          { toastId: "uniqueid" }
        );
      }
    }
  };

  useEffect(() => {
    if (!isbn_number_options?.length) return;

    // // When new batch is loaded, auto select next from new batch
    // const alreadySelected = isbn_number_options.find(
    //   (item) => item.value === segId
    // );

    // if (!alreadySelected) {
    if (steppingCalled && steppingDirection === "next") {
      const first = isbn_number_options[0];
      if (first?.value !== segId) {
        console.log("in22  if");

        onSegTitleSelect(first, "ean");
      } else if (isbn_number_options.length > 1) {
        console.log("in22 else if");
        onSegTitleSelect(isbn_number_options[1], "ean");
      }
    } else if (steppingCalled && steppingDirection == "prev") {
      const last = isbn_number_options[isbn_number_options.length - 1];
      if (last) onSegTitleSelect(last, "ean");
    }

    dispatch(SetSteppingCalled(false));

    // }
  }, [isbn_number_options]);

  console.log(isbn_number_options, "isbn_number_options");
  const sortedOptions = React.useMemo(() => {
    if (!selectedSegIsbn || !isbn_number_options.length)
      return isbn_number_options;

    const originalExists = isbn_number_options.find(
      (o) => o.value === selectedSegIsbn.value
    );
    if (!originalExists) return isbn_number_options;

    // Prepend a copy at the top
    return [selectedSegIsbn, ...isbn_number_options];
  }, [isbn_number_options, selectedSegIsbn]);

  const sortedOptionsTitle = React.useMemo(() => {
    if (!selectedSegTitle || !isbn_title_options.length)
      return isbn_title_options;

    const originalExistsTitle = isbn_title_options.find(
      (o) => o.value === selectedSegTitle.value
    );
    if (!originalExistsTitle) return isbn_title_options;

    // Prepend a copy at the top
    return [selectedSegTitle, ...isbn_title_options];
  }, [isbn_title_options, selectedSegTitle]);

  console.log(sortedOptions, "sortedOptions");

  useEffect(() => {
    if (segDetails && segDetails.FULL_TITLE && segDetails.EAN) {
      setSelectedSegTitle({
        label: segDetails.FULL_TITLE,
        value: segDetails._id,
      });
      setSelectedSegIsbn({ label: segDetails.EAN, value: segDetails._id });
    } else {
      setSelectedSegTitle(null);
      setSelectedSegIsbn(null);
    }
  }, [segDetails]);

  const testrow = useSelector((state: RootState) => state.OTISReducer.TestRow);

  const handleContinue = (value?: any, title?: string) => {
    console.log(
      "changing the value of inputtedData in handleContinue",
      inputtedDataSt
    );
    dispatch(setInputtedDataSt(true));

    const finalValue = value || pendingEanSelection;
    const finalTitle = title || pendingTitle;

    if (finalValue) {
      setText("Comparing Comp Title, Please Wait");
      setLoadingTest(true);

      // Reset table data
      const resetTableData = tableData
        .filter((record: any) => record.status !== 2)
        .map((record: any) => ({
          ...record,
          organizations: record.organizations
            .filter((org: any) => org.status !== 2)
            .map((org: any) => ({
              ...org,
              accounts: org.accounts
                .filter((account: any) => account.status !== 2)
                .map((account: any) => ({
                  ...account,
                  compInit: "",
                  compGross: "",
                  compNet: "",
                  Cpos_LTD: "",
                })),
            })),
        }))
        .filter((record: any) => record.organizations.length > 0);
      setText("Comparing Comp Title , Please Wait") // am
      handleEanSelection(finalValue, finalTitle);// am
      dispatch(updateSegOtisRecords(resetTableData));
      dispatch(setFinalData([]));
      setIsDisabled(false);
      setPendingEanSelection(null);
      setPendingTitle("");
    } else {
      console.log("under the !value", value);
      console.log("novalue", value);
      dispatch(clearCompInitAction());

      // Only show "Removing Selected Comp Title" if a comp title is actually selected
      if (eanSelectedValue) {
        setText("Removing Selected Comp Title, Please Wait");
      } else {
        // setText("Clearing All Data, Please Wait"); // Generic message when no comp title is selected
      }
      setLoadingTest(true); // Show loader before API call

      clearCompInit();

      const resetTableData = tableData
        .filter((record: any) => record.status !== 2)
        .map((record: any) => ({
          ...record,
          organizations: record.organizations
            .filter((org: any) => org.status !== 2)
            .map((org: any) => ({
              ...org,
              accounts: org.accounts
                .filter((account: any) => account.status !== 2)
                .map((account: any) => ({
                  ...account,
                  compInit: "",
                  compGross: "",
                  compNet: "",
                  Cpos_LTD: "",
                })),
            })),
        }));

      dispatch(updateSegOtisRecords(resetTableData));
      dispatch(setFinalData([]));

      // Clear filter states only when ISBN is removed
      if (finalTitle === "ean") {
        dispatch(setselectedDistribution(null));
        dispatch(setSelectedOrganization(null));
        dispatch(setSelectedAccountName(null));
      }

      setRender(!render);
      dispatch(emptySelectedOtisSummary());
      dispatch(emptydigPosData());
      setRender(!render);
      dispatch(updateEanNumberValue(null));
      dispatch(updateEanSelectedValue(null));
    }

    setSelectEan(false);
    dispatch(setInputtedData(false));
    dispatch(UpdateTestRow([]));
    setFormData({});

    if (addRow) {
      console.log("under the add row");
      dispatch(removeNewRows());
      dispatch(SetaddrowcancelData(true));
      setAddRow(false);
      dispatch(setFinalData(null));
      localStorage.removeItem("selectedDistribution");
      localStorage.removeItem("selectedAboveOrganization");
      localStorage.removeItem("selectedAboveAccountName");
      localStorage.removeItem("savedFilterState");
      localStorage.removeItem("saveFlag");
    }

    // setTimeout(() => {
    //   setLoadingTest(false);
    //   setText("");
    // }, 1000);
  };
  const handleCancel = () => {
    setPendingEanSelection(null);
    setPendingTitle("");
    setSelectEan(false);
  };
  const updateSalesNotes = (data: any) => {
    return data.map((record: any) => ({
      ...record,
      organizations: record.organizations.map((org: any) => ({
        ...org,
        accounts: org.accounts.map((account: any) => ({
          ...account,
          sales_notes: account.sales_notes === "0" ? "" : account.sales_notes,
        })),
      })),
    }));
  };

  useEffect(() => {
    // Guard clause: if any required dependency is missing, skip running the effect
    // if (!renderSeason || !segDetails?.EAN || !segId || selectedSeg || params.segId ) {
    //   return;
    // }
    // alert("this one")

    if (!renderSeason) {
      return;
    }
    const finalSegId =
      segId || selectedSeg || params.segId || localStorage.getItem("segId");
    const ean = segDetails?.EAN;
    clearCompInit();

    const timer = setTimeout(() => {
      if (!finalSegId) {
        dispatch(setNoSegId(true));
        return;
      }

      // When a comparable title is selected, the dedicated effect (below) loads OTIS with the full
      // payload. Dispatching fetchOTISRecord here too caused a second heavy call (~2× time) and a
      // response that replaced Redux without comp-title context — clearing the dropdown shortly after.
      // Use a ref so the timer sees the latest selection even if this effect did not re-run (deps are
      // only seg ids); a stale closure here dispatched a second fetch without eanSelectedValue.
      if (eanSelectedValueRef.current) {
        return;
      }

      const otisPayload: Record<string, unknown> = {
        segId: finalSegId,
        EAN: ean,
        hasMoreLimit: Number(segSummaryLimit) + 1,
      };
      const compEanLabel = eanNumberValue?.label;
      if (compEanLabel) {
        otisPayload.eanSelectedValue = compEanLabel;
      }
      if (shouldSkipDuplicateOtisFetch(otisPayload)) {
        return;
      }
      dispatch(FetchOTISRecord(otisPayload));
    }, 0);

    return () => {
      clearTimeout(timer);
      dispatch(updateSubmitBtn(true));
    };
  }, [segId, selectedSeg, params.segId]);
  // }, [segId, selectedSeg, segDetails?.EAN, params.segId]);

  const CustomSingleValue = (props: SingleValueProps<OptionType, false>) => {
    const { children } = props;
    return (
      <components.SingleValue {...props}>
        <div style={{ userSelect: "text" }}>{children}</div>
      </components.SingleValue>
    );
  };

  const SingleValueRenderer: React.FC<SingleValueProps<any>> = ({
    children,
    ...props
  }) => (
    <div
    >
      <components.SingleValue {...props}>{children}</components.SingleValue>
    </div>
  );

  const AutoScrollMenuList = (props: any) => {
    const { children, selectProps } = props;
    const menuListRef = useRef<HTMLDivElement>(null);
    const selectedOptionRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (menuListRef.current && selectedOptionRef.current) {
        const menuList = menuListRef.current;
        const selectedOption = selectedOptionRef.current;
        console.log(selectedOption, "selectedOption", menuList, "menuList");
        const scrollTop =
          selectedOption.offsetTop -
          menuList.offsetHeight / 2 +
          selectedOption.offsetHeight / 2;

        menuList.scrollTo({
          top: scrollTop,
          behavior: "auto",
        });
      }
    }, [selectProps.value]);

    const enhancedChildren = Children.map(children, (child: any) => {
      if (!child || typeof child !== "object") return child;

      const isSelected = child.props.isSelected;

      return cloneElement(child, {
        innerRef: isSelected ? selectedOptionRef : undefined,
      });
    });

    return (
      <components.MenuList {...props} innerRef={menuListRef}>
        {enhancedChildren}
      </components.MenuList>
    );
  };
  const showInitialSkeleton =
    (eans.isLoading || accounts.isLoading || FetchOtisLoading) &&
    !tableData?.length;
  const showInlineStatus = LoadingTest && !showInitialSkeleton;

  return (
    <>
      {inputtedData && isSelectEan && (
        <>
          <ConfirmationModal
            onDelete={() => handleContinue(pendingEanSelection, pendingTitle)}
            onClose={() => handleCancel()}
            isOpen={isSelectEan && inputtedData}
            title={
              "All inputs values entered are not saved yet and will be cleared."
            }
            type="continue"
            inputtedData={inputtedData}
            isSelectEan={isSelectEan}
          />
        </>
      )}
      {(inputtedData || inputtedDataSt) && isSelectEanSegTitle && (
        <>
          <ConfirmationModal
            onDelete={() => handleContinue2(pendingEanSegTitle, pendingTitle)}
            onClose={() => handleCancel2()}
            isOpen={isSelectEanSegTitle && (inputtedData || inputtedDataSt)}
            title={
              "All inputs values entered are not saved yet and will be cleared."
            }
            type="continue"
            inputtedData={inputtedData || inputtedDataSt}
            isSelectEan={isSelectEanSegTitle}
          />
        </>
      )}
      {showInlineStatus && (
        <OtisInlineProgress text={isText} />
      )}
      {showInitialSkeleton ? (
        <OtisDetailsSkeleton />
      ) : (
      <div className=" p-4 h-[80vh] overflow-y-auto">
        <ConfirmationModal
          onDelete={handleClearAll}
          onClose={() => setModal(false)}
          isOpen={isModal}
          title={"All inputs will be cleared."}
          type="clear"
          inputtedData={inputtedData}
          isSelectEan={isSelectEan}
        />
        <div className="flex flex-col  ">
          <div className={` ${isSmallScreen ? " grid" : "flex"} p-2"`}>
            <div className="overflow-x-auto lg:overflow-x-visible w-full ">
              <table className="border-collapse border border-neutral-200 w-full h-[39vh] table-fixed">
                  <colgroup>
                    <col style={{ width: "13%" }} />
                    <col style={{ width: "21%" }} />
                    <col style={{ width: "13%" }} />
                    <col style={{ width: "19%" }} />
                    <col style={{ width: "15%" }} />
                    <col style={{ width: "19%" }} />
                  </colgroup>
                <tbody>
                  <tr className="bg-white text-[13px]  text-center items-center ">
                    <td
                      colSpan={6}
                      className="relative font-semibold border-2 border-solid border-gray-200 text-center h-6 w-[20px] md:w-[120px]"
                    >
                      SEG Title
                      {/* Right-Aligned Navigation Icons (No Bubbles) */}
                      <div className="absolute right-2 top-[60%] -translate-y-1/2 flex items-center gap-1">
                        {/* Previous */}
                        <div
                          title="Previous ISBN"
                          className="relative group cursor-pointer"
                          onClick={onPrevISBN}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="3"
                            className="text-gray-800 hover:text-black transition"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M15 6l-6 6 6 6"
                            />
                          </svg>
                          {/* <span style={{ zIndex: 9999 }} className="absolute -top-5 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform bg-black text-white text-[10px] px-2 py-0.5 rounded shadow-md whitespace-nowrap z-9999">
                            Previous ISBN
                          </span> */}
                        </div>

                        {/* Next */}
                        <div
                          title="Next ISBN"
                          className="relative group cursor-pointer"
                          onClick={onNextISBN}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="3"
                            className="text-gray-800 hover:text-black transition"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 6l6 6-6 6"
                            />
                          </svg>
                          {/* <span style={{ zIndex: 9999 }} className="absolute -top-5 left-1/2 -translate-x-1/2 scale-0 group-hover:scale-100 transition-transform bg-black text-white text-[10px] px-2 py-0.5 rounded shadow-md whitespace-nowrap z-9999">
                            Next ISBN
                          </span> */}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px]  text-center items-center ">
                    <td className="font-semibold border-2 w-[100px] max-w-[100px] border-solid border-gray-200 text-center relative">
                      Title
                    </td>
                    <td
                      colSpan={5}
                      className="border-2 max-w-[20px]
                          h-5 whitespace-nowrap border-solid border-gray-200  overflow-y-auto text-left "
                    >
                      <div className="scroll-thin overflow-y-auto p-0">
                        {/* {segDetails.FULL_TITLE ? segDetails.FULL_TITLE : "-"} */}

                        <Controller
                          name={`segTableTitle`}
                          control={control}
                          render={({ field }) => (
                            <SelectList
                              // {...field}
                              // options={isbn_title_options}
                              options={sortedOptionsTitle}
                              isClearable={true}
                              value={selectedSegTitle}
                              onChange={(selected) => {
                                if (!isModalOpen) {
                                  // Only allow changes if no modal is open
onSegTitleSelect(selected, "title"); // Calls onSegTitleSelect with null when cleared
                                  if (!selected) {
                                    dispatch(resetSkipForOtis());
                                    dispatch(setIsbnStringForOtis(""));
                                    dispatch(
                                      fetchAllIsbnLists({
                                        prevSeason: filterSeasons,
                                        prevDivision: filterDivisions,
                                        prevImprint: filterImprint,
                                        prevPaperCutOffDate: selectedPaperCutOffDate,
                                        paperCutOffDate: selectedPaperCutOffDate,
                                        prevLdc: selectedLdc,
                                        ldc: selectedLdc,
                                        oldEans: oldISBNS,
                                        seasons: filterSeasons,
                                        divisions: filterDivisions,
                                        isbns: filterIsbns,
                                        imprint: filterImprint,
                                        selectedData: [],
                                        sortBy: SegReducer.titleSortBy,
                                        clickedIsbn:
                                          clickedIsbn || clickedIsbnFromLocal,
                                      })
                                    );
                                  }
                                }
                              }}
                              onMenuScrollToBottom={() => {
                                if (!isModalOpen && hasMore) {
                                  dispatch(updateIsbnSkipForOtis());
                                  dispatch(setPreviousSkip(isbnSkipForOtis));
                                }
                              }}
                              onMenuScrollToTop={() => {
                                if (!isModalOpen && hasPrevious) {
                                  dispatch(updateIsbnSkipMinus());
                                  dispatch(setPreviousSkip(isbnSkipForOtis));
                                }
                              }}
                              placeholder={`Select Title`}
                              onInputChange={(value, { action }) => {
                                if (!isModalOpen && action === "input-change") {
                                  if (value && value.trim() !== "" && selectedSegTitle?.value) {
                                    onSegTitleSelect(null, "title");
                                  }
                                  dispatch(resetSkipForOtis());
                                  dispatch(setIsbnStringForOtis(value));
                                }
                              }}
                              menuPortalTarget={document.body}
                              menuPlacement="auto"
                              components={{
                                DropdownIndicator: () => null,
                                MultiValueContainer: (props) => (
                                  <components.MultiValueContainer {...props}>
                                    <div className="flex">{props.children}</div>
                                  </components.MultiValueContainer>
                                ),
                                MenuList: AutoScrollMenuList,
                                SingleValue: SingleValueRenderer,
                              }}
                              className="border border-solid border-gray-300  font-poppins rounded-md w-full font-normal  lg:text-[12px]  overflow-x-auto max-w-[200px]sm:text-[10px]"
                              isDisabled={isModalOpen} // Disable dropdown when modal is open
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  pointerEvents: isModalOpen ? "none" : "auto", // Prevent interaction
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  marginLeft: 0,
                                  marginRight: 0,
                                  position: "absolute",
                                  left: "5px",
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  pointerEvents: isModalOpen ? "none" : "auto",
                                  left: 8,
                                  marginRight: "10px",
                                  caretColor: "auto",
                                }),
                                option: (provided, state) => ({
                                  ...provided,
                                  backgroundColor:
                                    state.isSelected || state.isFocused
                                      ? "#E6E6E6"
                                      : "",
                                  color: state.isSelected ? "black" : "black",
                                }),
                                multiValue: (provided) => ({
                                  ...provided,
                                  height: "30px",
                                  display: "flex",
                                  alignItems: "center",
                                  borderRadius: "6px",
                                  minWidth: "none",
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 1050,
                                  position: "absolute",
                                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                }),
                                menuPortal: (provided) => ({
                                  ...provided,
                                  zIndex: 1050,
                                }),
                                valueContainer: (provided) => ({
                                  position: "relative",
                                  maxWidth: "33vw",
                                  width: "100%",
                                  paddingLeft: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  height: "40px",
                                  paddingRight: "8px",
                                  overflowX: "auto",
                                  overflowY: "hidden",
                                  minWidth: "50px",
                                  boxSizing: "border-box",
                                  "::-webkit-scrollbar": {
                                    display: "none",
                                  },
                                }),
                                control: (provided) => ({
                                  display: "flex",
                                  height: "28px",
                                  overflow: "hidden",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  fontSize: "13px",
                                }),
                                menuList: (provided) => ({
                                  maxHeight: "175px",
                                  overflow: "hidden",
                                  overflowY: "auto",
                                  fontSize: "12px",
                                }),
                                clearIndicator: () => ({
                                  marginLeft: "1px",
                                  marginRight: "10px",
                                  marginTop: "5px",
                                  cursor: "pointer",
                                }),
                              }}
                            />
                          )}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px]  text-center items-center ">
                    <td className=" font-semibold border-2 border-solid border-gray-200 text-center relative">
                      ISBN
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[230px] h-6 max-w-[230px] whitespace-normal overflow-hidden">
                      <div className="scroll-thin overflow-hidden w-full">
                      <Controller
        name={`segTableIsbn`}
        control={control}
        render={({ field }) => (
          <div className="w-full">
            <SelectList
              options={sortedOptions}
              isClearable={true}
              value={selectedSegIsbn}
              onChange={(selected) => {
                if (!isModalOpen) { // Only allow changes if no modal is open
                  onSegTitleSelect(selected, "ean");
                  if (!selected) {
                    dispatch(resetSkipForOtis());
                    dispatch(setIsbnStringForOtis(""));
                    dispatch(
                      fetchAllIsbnLists({
                        prevSeason: filterSeasons,
                        prevDivision: filterDivisions,
                        prevImprint: filterImprint,
                        prevPaperCutOffDate: selectedPaperCutOffDate,
                        paperCutOffDate: selectedPaperCutOffDate,
                        prevLdc: selectedLdc,
                        ldc: selectedLdc,
                        oldEans: oldISBNS,
                        seasons: filterSeasons,
                        divisions: filterDivisions,
                        isbns: filterIsbns,
                        imprint: filterImprint,
                        selectedData: [],
                        sortBy: SegReducer.titleSortBy,
                        clickedIsbn: clickedIsbn || clickedIsbnFromLocal,
                      })
                    );
                  }
                }
              }}
              onMenuScrollToBottom={() => {
                if (!isModalOpen && hasMore) {
                  dispatch(updateIsbnSkipForOtis());
                }
              }}
              onMenuScrollToTop={() => {
                if (!isModalOpen && hasPrevious) {
                  dispatch(updateIsbnSkipMinus());
                }
              }}
              placeholder={`Select ISBN`}
              onInputChange={(value, { action }) => {
                if (!isModalOpen && action === "input-change") {
                  if (value && value.trim() !== "" && selectedSegIsbn?.value) {
                    onSegTitleSelect(null, "ean");
                  }
                  dispatch(resetSkipForOtis());
                  dispatch(setIsbnStringForOtis(value));
                }
              }}
              menuPortalTarget={document.body}
              menuPlacement="auto"
              className="border border-solid border-gray-300 font-poppins rounded-md w-full text-[12px]"
              isDisabled={isModalOpen} // Disable dropdown when modal is open
              components={{
                DropdownIndicator: () => null,
                MultiValueContainer: (props) => (
                  <components.MultiValueContainer {...props}>
                    <div className="flex">{props.children}</div>
                  </components.MultiValueContainer>
                ),
                MenuList: AutoScrollMenuList,
                SingleValue: SingleValueRenderer,
              }}
              styles={{
                container: (provided) => ({
                  ...provided,
                  pointerEvents: isModalOpen ? "none" : "auto", // Prevent interaction
                }),
                placeholder: (provided) => ({
                  ...provided,
                  marginLeft: 0,
                  marginRight: 0,
                  position: "absolute",
                  left: "5px",
                }),
                input: (provided) => ({
                  ...provided,
                  position: "relative",
                  pointerEvents: isModalOpen ? "none" : "auto",
                  textAlign: "left",
                  margin: 0,
                  padding: 0,
                  paddingLeft: "0px",
                }),
                option: (provided, state) => ({
                  ...provided,
                  backgroundColor: state.isSelected || state.isFocused ? "#E6E6E6" : "",
                  color: state.isSelected ? "black" : "black",
                }),
                multiValue: (provided) => ({
                  ...provided,
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "6px",
                  minWidth: "none",
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 1050,
                  position: "absolute",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }),
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 1050,
                }),
                valueContainer: (provided) => ({
                  position: "relative",
                  maxWidth: isSmallScreen ? "38vw" : "28vw",
                  width: "100%",
                  paddingLeft: "4px",
                  display: "flex",
                  alignItems: "center",
                  height: "25px",
                  paddingRight: "28px",
                  fontSize: "12px",
                  overflowX: "hidden",
                  overflowY: "hidden",
                  minWidth: "50px",
                  boxSizing: "border-box",
                  ...(isFirefox && {
                    maxWidth: "calc(28vw + 10px)",
                    scrollbarWidth: "thin",
                  }),
                }),
                control: (provided) => ({
                  display: "flex",
                  overflow: "hidden",
                  position: "relative",
                  height: "25px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  fontSize: "12px",
                }),
                menuList: (provided) => ({
                  maxHeight: "175px",
                  overflow: "hidden",
                  overflowY: "auto",
                  fontSize: "12px",
                }),
                clearIndicator: (base, { selectProps }) => ({
                  ...base,
                  cursor: "pointer",
                  padding: "0 4px",
                  color: "#000",
                  ":hover": { color: "#000" },
                }),
                singleValue: (base) => ({ ...base, fontSize: "12px" }),
                indicatorsContainer: (base) => ({
                  ...base,
                  position: "absolute",
                  right: 0,
                  top: 0,
                  height: "25px",
                  display: "flex",
                  alignItems: "center",
                  zIndex: 1,
                }),
              }}
            />
          </div>
        )}
      />
                      </div>
                    </td>
                    <td
                      colSpan={1}
                      className="font-semibold border-2 border-solid border-gray-200 text-center relative"
                    >
                      Author
                    </td>
                    <td
                      colSpan={1}
                      className="border-2 border-solid border-gray-200 text-center w-[115px] 
                        h-6 max-w-[115px] min-w-[115px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {segDetails.AUTHOR_1 ? segDetails.AUTHOR_1 : "-"}
                      </div>
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center  w-[100px] h-6 
                      max-w-[100px] font-semibold  whitespace-nowrap overflow-y-auto"
                    >
                      AFP
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px] min-w-[50px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {segDetails.ANNOUNCED_1ST_PRINTING__BEST ===
                          undefined ||
                        segDetails.ANNOUNCED_1ST_PRINTING__BEST === null ||
                        segDetails.ANNOUNCED_1ST_PRINTING__BEST === " "
                          ? "-"
                          : formatNumber(segDetails.ANNOUNCED_1ST_PRINTING__BEST) || "-"}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px]  text-center items-center  ">
                    <td className=" font-semibold border-2 border-solid border-gray-200 text-center relative">
                      Season
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[180px] h-6 max-w-[200px] whitespace-normal overflow-hidden">
                      {/* {data?.SEASON ? data?.SEASON :  } */}
                      {DataOfFetchotis?.SEASON ?? (filterSeasons?.[0] ?? "")}

                      {/* <div className="scroll-thin overflow-hidden min-w-[160px]">


                        <Controller
                          name={`segTableIsbn`}
                          control={control}
                          render={({ field }) => (
                            <div className=" w-full max-w-[165px] min-w-[162px] ml-[6px]  mr-[6px]">
                              <SelectList
                                // {...field}
                                // isClearable={true}
                                options={isbn_number_options}

                                isClearable={true}

                                value={selectedSegIsbn}

                                onChange={(selected) => {
                                  onSegTitleSelect(selected, "ean")


                                }}

                                onMenuScrollToBottom={() =>
                                  dispatch(updateIsbnSkip())
                                } placeholder={`Select ISBN`}
                                onInputChange={(value, { action }) => {
                                  // Checking if input is changed 
                                  if (action === "input-change") {
                                    dispatch(setIsbnString(value));
                                  }

                                }}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                className="border border-solid border-gray-300  font-poppins rounded-md  w-full lg:text-[14px] sm:text-[10px] "
                                components={{
                                  DropdownIndicator: () => null, // this removes the arrow
                                  MultiValueContainer: (props) => (
                                    <components.MultiValueContainer {...props}>
                                      <div className="flex">{props.children}</div>
                                    </components.MultiValueContainer>

                                  ),
                                  SingleValue: SingleValueRenderer
                                }}

                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    pointerEvents: "auto",
                                  }),
                                  placeholder: (provided) => ({
                                    ...provided,
                                    marginLeft: 0,
                                    marginRight: 0,
                                    position: 'absolute',
                                    left: '5px', // This should match your valueContainer paddingLeft
                                  }),

                                  input: (provided) => ({
                                    ...provided,
                                    position: 'relative',
                                    pointerEvents: "auto",
                                    textAlign: 'left',
                                    margin: 0,
                                    padding: 0,
                                    paddingLeft: '0px',
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor:
                                      state.isSelected || state.isFocused
                                        ? "#E6E6E6"
                                        : "",
                                    color: state.isSelected ? "black" : "black",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    borderRadius: "6px",
                                    minWidth: "none",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1050, // Ensure dropdown renders above the table
                                    position: "absolute", // Prevent dropdown resizing
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow
                                  }),
                                  menuPortal: (provided) => ({
                                    ...provided,
                                    zIndex: 1050, // Ensures dropdown renders above all elements
                                  }),
                                  valueContainer: (provided) => ({
                                    position: "relative",
                                    maxWidth: isSmallScreen ? "38vw" : "28vw",
                                    width: "100%",
                                    paddingLeft: "4px",
                                    display: "flex",
                                    alignItems: "center",
                                    height: "40px",
                                    paddingRight: "8px",
                                    overflowX: "auto",
                                    overflowY: "hidden",
                                    minWidth: "50px",
                                    boxSizing: "border-box",
                                    ...(isFirefox && {
                                      maxWidth: "calc(28vw + 10px)",
                                      scrollbarWidth: "thin",
                                    }),
                                  }),
                                  control: (provided) => ({
                                    display: "flex",
                                    // maxWidth:"37vw",
                                    // width:"510px",
                                    overflow: "hidden",
                                    height: "25px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    width: "100%",
                                    fontSize: "12px"
                                  }),
                                  menuList: (provided) => ({
                                    // ...provided,
                                    maxHeight: "175px",
                                    overflow: "hidden",
                                    overflowY: "auto",
                                    fontSize: "12px"
                                  }),
                                  clearIndicator: (base, { selectProps }) => ({
                                    ...base,
                                    // pointerEvents:  eans.isLoading ? "none" : "auto",
                                    //  marginLeft: "1px",
                                    // marginRight: '10px',
                                    // marginTop: "5px",
                                    // color: "gray",
                                    cursor: "pointer",
                                  }),
                                }}
                              />
                            </div>
                          )}
                        />
                      </div> */}
                    </td>
                    <td className="font-semibold  border-2 border-solid w-[65px] max-w-[65px] whitespace-nowrap border-gray-200 text-center relative">
                      Pub Date
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center min-w-[100px] h-6 
                      max-w-[100px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {segDetails.PUB_DATE?.length > 2
                          ? moment(segDetails.PUB_DATE).format("MM/DD/YYYY")
                          : " - "}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative">
                      Div
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center  w-[60px] 
                        h-7 max-w-[60px]  whitespace-nowrap overflow-y-auto "
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {segDetails.GROUP_1 ? segDetails.GROUP_1 : "-"}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px]  text-center items-center  ">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative">
                      US Price
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center   w-[100px]  h-6 max-w-[100px]  whitespace-nowrap overflow-y-auto">
                      <div className="scroll-thin overflow-y-auto">
                        {segDetails.US_PRICE
                          ? `${formatCurrency(segDetails.US_PRICE)}`
                          : "-"}
                      </div>
                    </td>
                    <td className="font-semibold  border-2 border-solid w-[90px] max-w-[90px] whitespace-nowrap border-gray-200 text-center relative">
                      Release Date
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px]  whitespace-nowrap overflow-y-auto"
                    >
                    <div className="scroll-thin overflow-y-auto">
                        {segDetails.RELEASE_DATE?.length > 2
                          ? moment(segDetails.RELEASE_DATE).format("MM/DD/YYYY")
                          : " - "}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative whitespace-normal max-w-[70px] leading-tight py-0.5">
                      Paper Cut Off Date
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[70px] max-w-[70px] h-6 p-0 min-w-0">
                      <div className="w-full max-w-full h-5 overflow-x-auto overflow-y-hidden whitespace-nowrap border border-gray-300 rounded-sm scroll-thin font-poppins flex items-center justify-center text-center">
                        {segDetails?.PAPER_CUT_OFF && moment(segDetails.PAPER_CUT_OFF).isValid()
                          ? moment(segDetails.PAPER_CUT_OFF).format("MM/DD/YY")
                          : "-"}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px]  text-center items-center  ">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative whitespace-nowrap">
                      Format
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[50px] max-w-[50px] h-6 min-w-0">
                      <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                        {segDetails.FORMAT ? segDetails.FORMAT : "-"}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative whitespace-nowrap">
                      Imprint
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[50px] max-w-[50px] h-6 min-w-0">
                      <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                        {segDetails.TESTIMPRINTFROMHNA
                          ? segDetails.TESTIMPRINTFROMHNA
                          : "-"}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative whitespace-nowrap">
                      Prnt
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[50px] max-w-[50px] h-6 min-w-0">
                      <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                        {segDetails.PRINT_RUN === undefined ||
                        segDetails.PRINT_RUN === null ||
                        segDetails.PRINT_RUN === " "
                          ? "-"
                          : formatNumber(segDetails.PRINT_RUN) || segDetails.PRINT_RUN}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] text-center items-center h-[70px]">
                    <td
                      className="font-semibold border-2 border-solid border-gray-200 text-center relative align-top h-[70px]"
                    >
                      Title Notes
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 p-1 align-top h-[70px]"
                    >
                      <textarea
                        value={SEGTitle}
                        onChange={(e) => {
                          const value = e.target.value;
                          dispatch(handleSaveButtonClear(true));
                          setIsDisabled(false);
                          if (value.length > 0) {
                            dispatch(updateSubmitBtn(false));
                            dispatch(setInputtedDataSt(true));
                            setIsDisabled(false);
                          } else {
                            setIsDisabled(true);
                          }
                          dispatch(updateSegTitle(e.target.value));
                        }}
                        className="h-full max-h-[70px] w-[95%] overflow-y-auto border border-gray-300 rounded-sm text-[13px] font-poppins
                          focus:outline-none focus:ring-1 focus:ring-blue-300 focus:border-blue-300 resize-none box-border"
                      ></textarea>
                    </td>
                    <td
                      colSpan={3}
                      className="border-2 border-solid border-gray-200 p-0 align-top h-[70px]"
                    >
                      <table className="border-collapse w-full h-full text-[13px]">
                        <tbody>
                          <tr className="bg-white text-[13px] text-center items-center">
                            <td className="font-semibold border-2 border-solid border-gray-200 text-center p-0.5 whitespace-nowrap">
                              Pub Goal
                            </td>
                            <td className="border-2 border-solid border-gray-200 text-center p-0.5 min-w-0">
                              <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                                {formatNumber(tableData.reduce((total: number, entry: any) => {
                                 // Same rule as the grid Total row: channel goal > sum of org goals > sum of account goals
                                 const num = (v: any) => { const raw = v && typeof v === "object" && v.$numberDecimal != null ? v.$numberDecimal : v; const n = Number(raw); return raw === "" || raw == null || !Number.isFinite(n) ? 0 : n; };
                                 const mainVal = num(entry?.main_pubgoal);
                                 if (mainVal !== 0) return total + mainVal;
                                 const orgs = entry?.organizations ?? [];
                                 const orgVals = orgs.map((org: any) => num(org?.org_pub_goal));
                                 if (orgVals.some((v: number) => v !== 0)) return total + orgVals.reduce((a: number, b: number) => a + b, 0);
                                 return total + orgs.reduce((orgTotal: number, org: any) => orgTotal + (org?.accounts ?? []).reduce((accTotal: number, account: any) => accTotal + num(account?.pub_goal), 0), 0);
                               }, 0))}
                              </div>
                            </td>
                            <td className="font-semibold border-2 border-solid border-gray-200 text-center p-0.5 whitespace-nowrap">
                              LDC
                            </td>
                            <td className="border-2 border-solid border-gray-200 text-center p-0.5 min-w-0">
                              <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                                {segDetails?.LDC && moment(segDetails.LDC).isValid() ? moment(segDetails.LDC).format("MM/DD/YYYY") : "-"}
                              </div>
                            </td>
                          </tr>
                          <tr className="bg-white text-[13px] text-center items-center">
                            <td className="font-semibold border-2 border-solid border-gray-200 text-center p-0.5 whitespace-nowrap">
                              Pages
                            </td>
                            <td className="border-2 border-solid border-gray-200 text-center p-0.5 min-w-0">
                              <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                                {segDetails.PAGES ? formatNumber(segDetails.PAGES) || segDetails.PAGES : "-"}
                              </div>
                            </td>
                            <td className="font-semibold border-2 border-solid border-gray-200 text-center p-0.5 whitespace-nowrap">
                              Trim
                            </td>
                            <td className="border-2 border-solid border-gray-200 text-center p-0.5 min-w-0">
                              <div className="scroll-thin overflow-x-auto overflow-y-hidden whitespace-nowrap">
                                {(segDetails?.TRIMLENGTH !== null && segDetails?.TRIMLENGTH !== " " && segDetails.TRIMLENGTH) || (segDetails?.TRIMWIDTH !== null && segDetails?.TRIMWIDTH !== " " && segDetails.TRIMWIDTH)
                                  ? `${segDetails?.TRIMLENGTH !== null && segDetails?.TRIMLENGTH !== " " && segDetails.TRIMLENGTH ? segDetails.TRIMLENGTH : ""}${segDetails?.TRIMWIDTH !== null && segDetails?.TRIMWIDTH !== " " && segDetails.TRIMWIDTH ? (segDetails.TRIMLENGTH ? ", " : "") + segDetails.TRIMWIDTH : ""}`.trim() || "-"
                                  : "-"}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="w-[4px] bg-black mx-2"></div>
            <div className="overflow-x-auto lg:overflow-x-visible w-full  ">
              <table className="border-collapse border border-neutral-200 w-full  h-[100%]">
                <tbody>
                  <tr className="bg-white text-[13px]  text-center items-center  ">
                    <td
                      colSpan={6}
                      className="font-semibold border-2 border-solid border-gray-200 text-center
                      h-6 w-[120px]
                      "
                    >
                      Comparative Title
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] text-center items-center h-[14px]">
                    <td className="font-semibold  border-2  border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      Title
                    </td>
                    <td
                      colSpan={5}
                      className="border-2 border-solid overflow-x-auto w-[100px] max-w-[100px] border-gray-200  text-center whitespace-nowrap"
                    >
                      <div className="w-full  content-center overflow-y-auto overflow-x-hidden">
                        <div className="flex w-full flex-col justify-center items-center gap-1">
                          <SearchSelect
                            crossClassname="top-1"
                            InputClassName="py-1 h-[30px]"
                            placeholder="Select Title"
                            className="w-full"
                            options={(eanTitleOptions ?? []).map((option) => ({
                              value: option.value ?? "",
                              label: option.label ?? "Unknown",
                            }))}
                            onInputChange={(value) => {
                              setIsDisabled(false);
                              dispatch(updateEanSearchStr(value));
                              if (value.length > 0) {
                                setIsDisabled(false);
                              } else {
                                setIsDisabled(true);
                              }
                            }}
                            value={eanSelectedValue}
                            onOptionSelect={(value) =>
                              onOptionSelect(value, "title")
                            }
                            fetchMoreOptions={() => {
                              dispatch(updateEanPage());
                            }}
                          />
                          {segDetails.FULL_TITLES &&
                          segDetails.FULL_TITLES.length ? (
                            <div className="overflow-x-auto overflow-y-hidden w-full  text-left">
                              {segDetails.FULL_TITLES?.map((data: any, id) => {
                                return (
                                  <span className="overflow-x-auto w-full bg-gray-200 rounded-lg mx-1 p-1 ">
                                    {data?.FULL_TITLE}{" "}
                                  </span>
                                );
                              })}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] text-center items-center">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      ISBN
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 text-center w-[100px]  max-w-[100px]  whitespace-nowrap"
                    >
                      <div className="w-full overflow-y-auto ">
                        <div className="flex flex-col  content-center items-center text-left gap-2">
                          <SearchSelect
                            InputClassName="py-1 min-h-[30px]"
                            crossClassname="top-1"
                            placeholder="Select ISBN"
                            className="w-full"
                            options={(eanNumberOptions ?? []).map((option) => ({
                              value: option.value ?? "",
                              label: option.label ?? "Unknown",
                            }))}
                            onInputChange={(value) => {
                              // dispatch(resetEanPage())
                                                         
                              setIsDisabled(false);
                              dispatch(updateEanSearchStr(value));
                              if (value.length > 0) {
                                setIsDisabled(false);
                              } else {
                                setIsDisabled(true);
                              }
                            }}
                            onBlur={() => {
                              const trimmedSearchStr = eans.searchStr?.trim();

                              if (
                                trimmedSearchStr &&
                                trimmedSearchStr.length > 0
                              ) {
                                debouncedFetchEans({
                                  type: "all",
                                  searchStr: trimmedSearchStr,
                                  page: eans.page,
                                  limit: eans.limit,
                                  oldEans: [],
                                });
                              }
                            }}
                            value={eanNumberValue}
                            onOptionSelect={(value) =>
                              onOptionSelect(value, "ean")
                            }
                            fetchMoreOptions={() => {
                              dispatch(updateEanPage());
                            }}
                          />
                          {segDetails.COMPETITIVE_TITLES &&
                          segDetails.COMPETITIVE_TITLES?.length > 2 ? (
                            <div className="overflow-x-auto w-full overflow-y-hidden ">
                              {segDetails["COMPETITIVE_TITLES"]
                                ?.split(",")
                                .map((number) => {
                                  return (
                                    <span className="bg-gray-200 mx-1 rounded-lg p-1">
                                      {" "}
                                      {number}
                                    </span>
                                  );
                                })}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      Author
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 text-center w-[100px]  h-6 max-w-[100px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.AUTHOR_1
                          ? selectedOtisSummary.AUTHOR_1
                          : "-"}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] h-[36px] text-center items-center ">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      Season
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 text-center w-[100px]  h-6 max-w-[100px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {dataOfComp?.SEASON ? dataOfComp?.SEASON : "-"}
                      </div>
                    </td>
                    <td
                      className="font-semibold border-2 border-solid border-gray-200 w-[100px] max-w-[100px] text-center relative 
                      "
                    >
                      Pub Date
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px] whitespace-nowrap overflow-y-auto "
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.PUB_DATE?.length > 2
                          ? moment(selectedOtisSummary.PUB_DATE).format(
                              "MM/DD/YYYY"
                            )
                          : " - "}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] h-[36px] text-center items-center">
                    <td className="border-2 border-solid border-gray-200 text-center font-semibold  whitespace-nowrap overflow-y-auto">
                      Format
                    </td>
                    <td
                      colSpan={2}
                      className="border-2  border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px] whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.FORMAT
                          ? selectedOtisSummary.FORMAT
                          : "-"}
                      </div>
                    </td>
                    <td
                      className="font-semibold border-2 border-solid border-gray-200 w-[100px] max-w-[100px] text-center relative whitespace-nowrap 
                      "
                    >
                      Release Date
                    </td>
                    <td
                      colSpan={2}
                      className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px] whitespace-nowrap overflow-y-auto "
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.RELEASE_DATE?.length > 2
                          ? moment(selectedOtisSummary.RELEASE_DATE).format(
                              "MM/DD/YYYY"
                            )
                          : " - "}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] h-[36px] text-center items-center ">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      US Price
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center   w-[100px]  h-6 max-w-[100px]  whitespace-nowrap overflow-y-auto">
                      <div className="scroll-thin overflow-y-auto">
                        {" "}
                        {selectedOtisSummary?.US_PRICE
                          ? `${formatCurrency(selectedOtisSummary.US_PRICE)}`
                          : "-"}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 p-1 text-center relative w-[100px] max-w-[100px]">
                      LTD
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 p-1 text-center w-[100px] h-6 
                      max-w-[100px]  whitespace-nowrap overflow-y-auto "
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.LTD_GROSS_UNITS
                          ? formatNumber(selectedOtisSummary.LTD_GROSS_UNITS) ||
                            selectedOtisSummary.LTD_GROSS_UNITS
                          : "-"}
                      </div>
                    </td>
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px]">
                      Div
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 max-w-[100px] whitespace-nowrap overflow-y-auto">
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.GROUP_1
                          ? selectedOtisSummary?.GROUP_1
                          : "-"}
                      </div>
                    </td>
                  </tr>
                  <tr className="bg-white text-[13px] h-[36px] text-center items-center  ">
                    <td className="font-semibold border-2 border-solid border-gray-200 text-center relative w-[100px] max-w-[100px] whitespace-nowrap ">
                      eBook Sales
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 text-center w-[100px] h-6 
                      max-w-[100px] whitespace-nowrap overflow-y-auto "
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {digPosData.data.total_ordered_units
                          ? formatNumber(digPosData.data.total_ordered_units) ||
                            digPosData.data.total_ordered_units
                          : digPosData.data.total_ordered_units === 0
                          ? 0
                          : " - "}
                      </div>
                    </td>
                    <td
                      className="font-semibold border-2 border-solid border-gray-200 text-center
                        w-[100px] max-w-[100px] relative"
                    >
                      Imprint
                    </td>
                    <td className="border-2 border-solid border-gray-200 text-center w-[100px]  h-6 max-w-[100px]  whitespace-nowrap overflow-y-auto">
                      <div className="scroll-thin overflow-y-auto"> {selectedOtisSummary?.TESTIMPRINTFROMHNA
                          ? selectedOtisSummary?.TESTIMPRINTFROMHNA
                          : "-"}</div>
                    </td>
                    <td
                      className=" border-2 border-solid border-gray-200 p-1 text-center w-[100px] h-6 
                      max-w-[100px] whitespace-nowrap overflow-y-auto font-semibold "
                    >
                      BkSn Pos
                    </td>
                    <td
                      className="border-2 border-solid border-gray-200 p-1 text-center w-[100px] 
                      max-w-[100px]  whitespace-nowrap overflow-y-auto"
                    >
                      <div className="scroll-thin overflow-y-auto">
                        {selectedOtisSummary?.bksnPos
                          ? formatNumber(selectedOtisSummary.bksnPos) ||
                            selectedOtisSummary.bksnPos
                          : "-"}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="h-auto " style={{ zIndex: "10" }}>
          <TestTable
            data={newData ? newData : tableData}
            LoadingTest={LoadingTest}
            setLoadingTest={setLoadingTest}
            handleRemoveRow={handleRemoveRow}
            handleResetSeason={handleResetSeason}
            render={render}
            setRender={setRender}
            addRow={addRow}
            callOtis={callOtisRecord}
            accountData={accountData}
            setAccountData={setAccountData}
            objectToUpdate={objectToUpdate}
            setObjectToUpdate={setObjectToUpdate}
            handleAddRow={handleAddRow}
            handleSaveAll={handleSaveAll}
            setModal={setModal}
            formData={formData} // Pass formData
            setFormData={setFormData} // Add this
            isSaving={isSaving}
            eansLoading={eans.isLoading}
            accountsLoading={accounts.isLoading}
            // otisSegIsLoading={otisSegIsLoading}
            userRole={userData?.role ?? []}
            otisSegIsLoading={false}
            setText={setText}
          />
        </div>
      </div>
      )}
    </>
  );
};

export default OTISRecordsTable;